import {
  Injectable,
  PLATFORM_ID,
  NgZone,
  ViewChild,
  Injector,
  forwardRef,
  Inject,
} from '@angular/core';
import {
  AngularfirestoreCoolStoreService,
  AngularfirestoreVideoStoreService,
} from './angularfirestore-extension.service';
import { from, Observable } from 'rxjs';
import { AngularFirestore } from 'angularfire2/firestore';
import firebase from 'firebase/app';
import { FirebaseConstants } from '../shared/FirebaseConstants';
import {
  AngularFireStorage,
  AngularFireStorageReference,
  AngularFireUploadTask,
} from '@angular/fire/storage';
import { AngularFireAuth } from '@angular/fire/auth';
import { HttpClient } from '@angular/common/http';
import { switchMap } from 'rxjs/operators';
//import * as admin from 'firebase-admin';
// const admin = require('firebase-admin');
import { Subscription } from 'rxjs';
import { RouterOutlet, Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { MenuService } from './menu-service';
import { AuthService } from './auth.service';
import { access } from 'fs';
import { add } from 'date-fns';
import { FirebaseService } from './firebase.service';
import { cfRegionLinks } from '../helper/cfRegionLinks';
import { transform } from '@progress/kendo-drawing/dist/npm/geometry';
export interface FILE {
  name: string;
  filepath: string;
}

@Injectable({
  providedIn: 'root',
})
export class CustomerdatabaseService {
  public bewerber;
  public bewerbervertraege: firebase.firestore.CollectionReference;
  coolClctn$: Observable<any>;
  perfectClctn$: Observable<any>;
  app2 = null;
  auth: AngularFireAuth;
  customerStorage: AngularFireStorage;
  isPremium = false;
  isCustomer = false;
  isFreemium = false;
  customerNumber;
  newContractId = '';
  userId = '';
  static joinJobOffers = [];
  // userStorage;
  joinApiKey = '';
  JoinBewerber = [];
  HostingURL = '';
  teammemberId = '';
  db;
  calendar = '';
  cloudFunctionURL = '';
  cloudFunctionWaitingVideoURL = '';
  userEmail = '';
  public applicantProfile: firebase.firestore.CollectionReference;
  public monaactivities: firebase.firestore.CollectionReference;
  public applicantProfileImport: firebase.firestore.CollectionReference;
  public jobs: firebase.firestore.CollectionReference;
  public agentFolders: firebase.firestore.CollectionReference;
  customerAdminEmailAdress = '';
  subscription: Subscription;
  InternetStatus = 'green';
  assessmentTests: any[] = [];
  businessName = '';
  businessLogo = '';
  @ViewChild(RouterOutlet) outlet: RouterOutlet;
  unsubscribe: Subscription;
  jobOfferSubscription: any;
  thirtyDaysAgo: Date = new Date();
  createdQuery: any;

  // AI disclaimers
  seenDisclaimer = false;
  confirmedDisclaimer = false;
  currentPlan = '';

  accountId = "";
  lastEmail: any = null;
  blackListItems: any[] = [];
  loading = false;
  lastDoc: any;
  public hasMoreDataBlacklist: boolean = true;

  salesEmailsData: any;
  salesEmailDataHistory: any;
  companiesData: any;

  private firebaseService: any;

  constructor(
    private coolStore: AngularfirestoreCoolStoreService,
    private videoStore: AngularfirestoreVideoStoreService,
    private zone: NgZone,
    private storage: AngularFireStorage,
    private http: HttpClient,
    private menuService: MenuService,
    private alertCtrl: AlertController,
    private authService: AuthService,
    private injector: Injector,
  ) {
    this.applicantProfile = firebase.firestore().collection('applicantProfile');
    this.applicantProfileImport = firebase.firestore().collection('applicants');
    this.monaactivities = firebase.firestore().collection('activities');
    this.jobs = firebase.firestore().collection('JobsToCallApplicants');
    this.agentFolders = firebase.firestore().collection('agentFolders');
    // const source = interval(1000);
    // this.subscription = source.subscribe(val => this.speedtest());
    console.log('init customerDB');
    this.thirtyDaysAgo.setDate(this.thirtyDaysAgo.getDate() - 30);
    // fallback for applicants page to pull from
  }

  sendContacting(testMail, testMobil, testFirstName, testLastName, filePath, selectedJobId, userEmail) {
    this.app2.firestore.collection('emailapplicants').add({
      created: new Date(),
      createdEmailZapier: new Date(),
      email: testMail || '',
      mobilnummer: testMobil || '',
      vorname: testFirstName || '',
      nachname: testLastName || '',
      cv: filePath || '',
      emailTextHTML: 'test',
      emailTextPlain: 'test',
      senderEmail: userEmail || '',
      jobId: selectedJobId || '',
      quelle: 'singleContacting'
    });
  }

  getCvPublicUrl() { }

  setcurrentPlan(plan) {
    this.currentPlan = plan || '';
    this.menuService.userRole$.next(plan);
    console.log('currentPlan', this.currentPlan);
  }

  returnCurrentPlan() {
    return this.currentPlan;
  }

  getAccountId() {
    return this.accountId;
  }

  getVideos() {
    this.videoStore.firestore
      .collection('videos')
      .get()
      .then((snap) => {
        console.log(snap);
      });
  }

  speedtest() {
    console.log('runnin');
    if (this.app2 == undefined) {
      // window.open("https://mona-ai-pwa-firebase.web.app")
    }
  }

  getUserData(email) {
    return this.coolStore.firestore.collection('customers');
  }

  getCustomerNumber() {
    return this.customerNumber;
  }

  recontactApplicants() {
    let date = new Date("2025-04-06");
    this.app2.firestore.collection("applicants").where("created", ">=", date).get().then(snapshot => {
      snapshot.forEach(doc => {
        if (doc.exists) {
          let data = doc.data();
          let jobOfferId = data.jobOfferId;
          if (jobOfferId == undefined || jobOfferId == "") {
            let applicantApp = data.applicant;
            if (applicantApp) {
              let applicantMandantId = applicantApp.niederlassung;
              if (applicantMandantId) {
                this.getProfile().get().then((snap) => {
                  let docs = snap.docs;
                  let docLength = docs.length;
                  if (docLength > 0) {
                    let docData = docs[0].data();
                    let locations = docData.standorte;
                    if (locations) {
                      for (const loc of locations) {
                        if (loc && loc.locationId) {
                          if (loc.locationId == applicantMandantId) {
                            let name = loc.name;
                            this.app2.firestore.collection("applicants").doc(doc.id).update({
                              jobOfferId: "DhUawKZkUTARVBFfJaCo",
                              jobOfferWorkflow: name
                            }).then(() => {
                              console.log("updated");
                            }).catch((error) => {
                              console.error("Error updating document: ", error);
                            });
                            break;
                          }
                        }
                      }
                    }
                  }
                })
              } else {
                this.app2.firestore.collection("applicants").doc(doc.id).update({
                  jobOfferId: "DhUawKZkUTARVBFfJaCo",
                }).then(() => {
                  console.log("updated");
                }).catch((error) => {
                  console.error("Error updating document: ", error);
                });
              }
            } else {
              this.app2.firestore.collection("applicants").doc(doc.id).update({
                jobOfferId: "DhUawKZkUTARVBFfJaCo",
              }).then(() => {
                console.log("updated");
              }).catch((error) => {
                console.error("Error updating document: ", error);
              });
            }
          }
        }
      });
    });
  }

  saveCustomerNumber(customerNumber) {
    this.customerNumber = customerNumber;
  }

  getCloudFunctionURL() {
    return this.cloudFunctionURL;
  }

  getCloudFunctionWaitingVideoURL() {
    return this.cloudFunctionWaitingVideoURL;
  }

  saveSalesEmailsData(data, history, companies) {
    console.log('data', data);
    console.log('history', history);
    console.log('companies', companies);
    this.salesEmailsData = data;
    this.salesEmailDataHistory = history;
    this.companiesData = companies;
  }

  returnSalesEmailsData() {
    return this.salesEmailsData;
  }

  returnSalesEmailDataHistory() {
    return this.salesEmailDataHistory;
  }

  returnCompaniesData() {
    return this.companiesData;
  }

  returnSalesEmails() {
    return this.app2.firestore.collection('emailsToBeSent');
  }

  sendSalesEmails(id) {
    return this.app2.firestore.collection('emailsToBeSent').doc(id).update({
      sent: true,
    });
  }

  //Ray added this code
  async storeAssessmentTest(doc: any) {
    const collectionRef = this.app2.firestore.collection('assessmentTests');

    try {
      // Write a document to the 'assessmentTests' collection
      await collectionRef.add(doc);
      console.log(
        'Document added to assessmentTests collection in mona-ai-intern database',
      );
    } catch (error) {
      console.error('Error writing document: ', error);
    }
  }

  async updateAssessmentTest(docId: any, doc: any) {
    const collectionRef = this.app2.firestore.collection('assessmentTests');
    const docRef = collectionRef.doc(docId); // Reference to the specific document

    try {
      // Write a document to the 'assessmentTests' collection
      await docRef.update(doc);
      console.log(
        `Document with ID ${docId} updated in assessmentTests collection`,
      );
    } catch (error) {
      console.error('Error writing document: ', error);
    }
  }

  getAssessmentTests(): firebase.firestore.CollectionReference {
    return this.app2.firestore.collection('assessmentTests');
  }

  getAssessmentTestDetail(id): firebase.firestore.DocumentReference {
    return this.app2.firestore.collection('assessmentTests').doc(id);
  }

  getDocumentById(docId: string) {
    return this.app2.doc(`assessmentTests/${docId}`).valueChanges();
  }

  getActivities(): firebase.firestore.CollectionReference {
    return this.app2.firestore.collection('activities');
  }

  getCalendar() {
    if (this.calendar != '') {
      return this.calendar;
    } else {
      return 'no calendar';
    }
  }

  getProjectId() {
    return this.db.projectId;
  }

  saveCompanyLogo(logo) {
    this.businessLogo = logo;
  }

  async connectDB(data) {
    if (data) {
      this.db = data.database;
      console.log('this.db', data);
      this.HostingURL = 'https://' + this.db.projectId + '.firebaseapp.com';
      this.joinApiKey = data.joinapikey;
      this.calendar = data.calendar;
      this.customerAdminEmailAdress = data.email;
      this.cloudFunctionURL = data.cloudFunctionURL || '';
      this.cloudFunctionWaitingVideoURL =
        data.cloudFunctionWaitingVideoURL || '';
      this.customerNumber = data.kundennummer;
      this.accountId = data.account_id;
      console.log('this.accountId', this.accountId);
      const platformId = PLATFORM_ID;
      const settings = {};

      this.app2 = new AngularFirestore(
        this.db,
        'CustomerDatabase',
        false,
        null,
        platformId,
        this.zone,
        settings,
      );
      if (this.app2 != undefined) {
        if (this.accountId != '' && this.accountId != undefined) {
          this.app2.firestore = this.app2.firestore
            .collection('accounts')
            .doc(this.accountId);
          console.log('app2 initialized');
        }
        console.log('app2 initialized');
        this.createdQuery = this.getApplicants()
          .where('created', '>=', this.thirtyDaysAgo)
          .orderBy('created', 'desc')
          .limit(500);
        // .limit(727);
        // .limit(50)
      }
      this.getProfile().get().then((snap) => {
        var docs = snap.docs;
        var docLength = docs.length;
        if (docLength > 0) {
          this.businessName = docs[0].data().businessName || '';
          this.businessLogo = docs[0].data().companyLogo || '';
          this.menuService.setCompanyLogo(this.businessLogo);
        }
      })

      return true;
    } else {
      return false;
    }
  }

  async checkIfUsersExists(userId) {
    try {
      const userRef = await this.app2.firestore
        .collection('users')
        .doc(userId)
        .get();
      if (userRef.exists) {
        console.log('exists');
        return true;
      } else {
        console.log('Nope');
        return false;
      }
    } catch (err) {
      console.log('err', err);
    }
  }

  createuserInsideUsers(uid) {
    this.app2.firestore.collection('users').doc(uid).set({
      credits: 999999, // TODO change later for production and upselling
    });
  }

  retreiveUserCreditsAllTheTimeUpToDate(callback: (credits: number) => void) {
    console.log('this.authservice', this.authService.returnAccountId());
    console.log('this.authservice', this.authService.returnUserId());
    if (this.app2 == undefined) {
      console.log('app2 is undefined');
      return;
    }
    let accountId = this.authService.returnAccountId();
    // let userId = this.authService.returnUserId();
    if (accountId != null && accountId != undefined && accountId != '') {
      return this.app2.firestore
        .collection('users')
        .doc(this.authService.returnUserId())
        .onSnapshot(
          (doc) => {
            if (doc.exists) {
              const userData = doc.data();
              const credits = userData?.credits ?? 0; // Assuming 'credits' is the field name
              callback(credits);
            } else {
              callback(0);
              console.error('No such document!');
            }
          },
          (error) => {
            console.error('Error retrieving user credits: ', error);
          },
        );
      // }
    } else {
      return this.app2.firestore
        .collection('users')
        .doc(this.authService.returnUserId())
        .onSnapshot(
          (doc) => {
            if (doc.exists) {
              const userData = doc.data();
              const credits = userData?.credits ?? 0; // Assuming 'credits' is the field name
              callback(credits);
            } else {
              callback(0);
              console.error('No such document!');
            }
          },
          (error) => {
            console.error('Error retrieving user credits: ', error);
          },
        );
    }
  }

  returnCustomerDB() {
    return this.app2;
  }

  getApplicantMailings() {
    return this.app2.firestore.collection('applicantmailing');
  }

  returnBusinessLogo() {
    return this.businessLogo;
  }

  returnBusinessName() {
    return this.businessName || '';
  }

  returnCustomerAdminEmailAdress() {
    return this.customerAdminEmailAdress;
  }

  ApplicantEmailCorrespondence(item, email, vorlage, url, anrede) {
    return this.app2.firestore.collection('applicantmailing').add({
      customer: item,
      email: email,
      vorlage: vorlage,
      url: url,
      anrede: anrede,
      created: new Date(),
      createdGerman: new Date().toLocaleDateString('de-DE'),
      createdISO: new Date().toISOString(),
      createdISODate: new Date().toISOString().split('T')[0],
    });
  }

  CustomerEmailCorrespondence(email, candidate) {
    return this.app2.firestore.collection('customermailing').add({
      email: email,
      candidate: candidate,
      created: new Date(),
      createdGerman: new Date().toLocaleDateString('de-DE'),
      createdISO: new Date().toISOString(),
      createdISODate: new Date().toISOString().split('T')[0],
    });
  }

  getWorkflows(): firebase.firestore.CollectionReference {
    return this.app2.firestore.collection('workflows');
  }

  getWorkflowDetail(id): firebase.firestore.DocumentReference {
    return this.app2.firestore.collection('workflows').doc(id);
  }

  updateWorkflow(id, form) {
    console.log(form);
    console.log(id);
    return this.app2.firestore
      .collection('workflows')
      .doc(id)
      .update({
        name: form.name || '',
        appliesto: form.appliesto || '',
        whenthishappens: form.whenthishappens || '',
        dothis: form.dothis || '',
        id: form.id || '',
        receiver: form.receiver || '',
        calendlyLink: form.calendlyLink || '',
        when: form.when || '',
        receivers: form.receivers || [],
        updated: new Date() || '',
        updatedGerman: new Date().toLocaleDateString('de-DE') || '',
        updatedISO: new Date().toISOString() || '',
        // new ones
        workflowSendEmailSubject: form.workflowSendEmailSubject,
        workflowSendEmailMessage: form.workflowSendEmailMessage || '',
        workflowSendEmailTitle: form.workflowSendEmailTitle || '',
        emails: form.emails || [],
        emailText: form.emailText || '',
        smsCountryCode: form.smsCountryCode || '',
        smsPhoneNumbers: form.smsPhoneNumbers || [],
        //added phoneNumber and WhatsappNumber (smsPhoneNumbers when undefined should also be [], maybe change in the future) (31.10.2024)
        callPhoneNumbers: form.callPhoneNumbers || [],
        whatsAppPhoneNumbers: form.whatsAppPhoneNumbers || [],
        smsText: form.smsText || '',
        information: form.information || [],
        dynamicAttachment: form.dynamicAttachment || [],
        customTime: form.customTime || {},
        attachment: form.attachment || '',
        attachmentURL: form.attachmentURL || '',
        document: form.document || '',
        documentURL: form.documentURL || '',
        documentName: form.documentName || '',
        prompt: form.prompt || '',
        agent: form.agent || {},
        // superior changes
        lastChosenWorkflow: form.lastChosenWorkflow || '',
        priorityOfWorkflow: form.priorityOfWorkflow || '',
        subWorkflows: form.subWorkflows || [],
        lastChosenWorkflowMatching: form.lastChosenWorkflowMatching || '',
        reminder: form.reminder || {},
      });
  }

  getJoinApiKey() {
    if (this.joinApiKey) {
      return this.joinApiKey;
    } else {
      return 'noApiKey';
    }
  }

  getHostingURL() {
    if (this.HostingURL) {
      return this.HostingURL;
    } else {
      return 'noHostingURL';
    }
  }

  getUserDB() {
    return this.app2;
  }

  getJobOffers(): firebase.firestore.CollectionReference {
    return this.app2.firestore.collection(FirebaseConstants.jobOffers);
  }

  getJobOffersProcessed(): Promise<any> {
    console.log('getJobOffersProcessed');
    const start = performance.now();
    return new Promise(async (resolve, reject) => {
      let allJobOffers = [];
      this.jobOfferSubscription = this.app2.firestore
        .collection(FirebaseConstants.jobOffers)
        .onSnapshot(
          async (snap: { docs: any }) => {
            console.log('getJobOffersProcessed inside snapshot');
            var docs = snap.docs;
            var docLength = docs.length;
            if (docLength > 0) {
              docs.forEach((doc) => {
                var data = doc.data();
                data.id = doc.id;
                allJobOffers.push(data);
              });
              const end = performance.now();
              console.log(
                'Time taken to fetch jobOffers: ',
                (end - start) / 1000,
                ' seconds',
              );
              console.log('--- Fetched jobOffers:: ', allJobOffers);
              //removing snapshot
              this.jobOfferSubscription();
              resolve(allJobOffers);
            } else {
              //removing snapshot
              this.jobOfferSubscription();
              resolve([]);
            }
          },
          (error) => {
            console.log(error);
            reject(error);
          },
        );
    });
  }

  getDeletedJobOffers(): firebase.firestore.CollectionReference {
    return this.app2.firestore.collection(FirebaseConstants.deletedJobOffers);
  }
  getDeletedJobOffersDetail(id): firebase.firestore.DocumentReference {
    return this.app2.firestore
      .collection(FirebaseConstants.deletedJobOffers)
      .doc(id);
  }

  getJobOffersDetail(id): firebase.firestore.DocumentReference {
    return this.app2.firestore.collection(FirebaseConstants.jobOffers).doc(id);
  }

  getJOINJobOffers() {
    return CustomerdatabaseService.joinJobOffers;
  }

  setJOINJobOffer(jobOffer) {
    var isSet = false;
    var id = jobOffer.id;
    CustomerdatabaseService.joinJobOffers.forEach((snap) => {
      var snapId = snap.id;
      if (id == snapId) {
        isSet = true;
      }
    });
    console.log(isSet);
    if (!isSet) {
      CustomerdatabaseService.joinJobOffers.push(jobOffer);
    }
  }

  getCodingApplicants(): firebase.firestore.CollectionReference {
    return this.app2.firestore.collection(FirebaseConstants.codingapplicants);
  }

  getCoderbyteApplicants(): firebase.firestore.CollectionReference {
    return this.app2.firestore.collection(
      FirebaseConstants.coderbyteapplicants,
    );
  }

  getApplicantDetail(id): firebase.firestore.DocumentReference {
    return this.app2.firestore.collection(FirebaseConstants.applicants).doc(id);
  }

  updateAvitea(applicantId, workflowId) {
    return this.app2.firestore.collection(FirebaseConstants.applicants).doc(applicantId).update({
      workflowArray: [workflowId]
    });
  }

  getApplicantFiles(id) {
    return this.getApplicantDetail(id)
      .get()
      .then((snap) => {
        var data = snap.data();
        if (data) {
          if (data.files) {
            if (data.files.length > 0) {
              return data.files;
            }
          }
        }
      });
  }

  saveApplicant(bewerber) {
    this.JoinBewerber = bewerber;
  }

  deleteApplicant(applicantId) {
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(applicantId)
      .delete();
  }

  async archiveApplicant(applicantId) {
    // First add the applicant to archived collection
    await this.addToArchivedApplicants(applicantId);
  }

  /**
   * Add applicant to deleted applicants collection in Firestore.
   * @param applicantToDelete
   */
  async addToDeletedApplicants(applicantToDelete) {
    let applicantData = await this.getApplicantDetail2(applicantToDelete).get();
    if (applicantData) {
      let data = applicantData.data();
      if (data) {
        if (data.cv_embedding) {
          delete data.cv_embedding;
        }
        await this.app2.firestore
          .collection(FirebaseConstants.deletedApplicants).doc(applicantToDelete).set(data);
      }
    }
  }

  /**
   * Add applicant to archived applicants collection in Firestore.
   * @param archivedApplicant
   */
  async addToArchivedApplicants(archivedApplicant) {
    let applicantData = await this.getApplicantDetail2(archivedApplicant).get();
    if (applicantData) {
      let data = applicantData.data();

      data.archived = true;

      if (data) {
        if (data.cv_embedding) {
          delete data.cv_embedding;
        }
        await this.app2.firestore.collection(FirebaseConstants.applicants).doc(archivedApplicant).set(data);
      }
    }
  }

  async reactivateApplicant(applicantId) {
    let applicantData = await this.app2.firestore.collection(FirebaseConstants.applicants).doc(applicantId).get();
    if (applicantData.exists) {
      let data = applicantData.data();
      if (data) {
        if (data.cv_embedding) {
          delete data.cv_embedding;
        }
        if (data.archived) {
          delete data.archived;
        }
        await this.app2.firestore.collection(FirebaseConstants.applicants).doc(applicantId).set(data);
      }
    }
  }

  async getAllApplicantsLast30Days(): Promise<any[]> {
    return new Promise(async (resolve, reject) => {
      let allApplicants = [];
      let thirtyDaysAgo = new Date();
      thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
      this.app2.firestore
        .collection(FirebaseConstants.applicants)
        .where('created', '>=', thirtyDaysAgo)
        .orderBy('created', 'desc')
        .get()
        .then(async (snap) => {
          let docs = snap.docs;
          let docLength = docs.length;
          if (docLength > 0) {
            docs.forEach((doc) => {
              var data = doc.data();
              data.id = doc.id;
              allApplicants.push(data);
            });
            resolve(allApplicants);
          } else {
            resolve([]);
          }
        });
    });
  }

  getJoinApplicant() {
    return this.JoinBewerber;
  }

  // async archiveApplicant(id, archived) {
  //   return this.app2.firestore.collection('applicants').doc(id).update({
  //     archived: archived,
  //   });
  // }

  getApplicantDetail2(id): firebase.firestore.DocumentReference {
    return this.app2.firestore.collection('applicants').doc(id);
  }

  getProfile(): firebase.firestore.CollectionReference {
    if (this.app2 == undefined) {
      console.log('app2 is undefined');
      return null;
    }
    return this.app2.firestore.collection(FirebaseConstants.branding);
  }

  saveDataflow(dataflow: { sources: any[], endpoints: any[] }) {
    return this.getProfile()
      .get()
      .then((snap) => {
        var docs = snap.docs;
        var docLength = docs.length;
        if (docLength > 0) {
          var id = docs[0].id;
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({ dataflow: dataflow });
        }
      });
  }

  async getProfileLanguage() {
    return await this.getProfile()
      .get()
      .then((snap) => {
        var docs = snap.docs;
        var docLength = docs.length;
        if (docLength > 0) {
          return docs[0].data().platformLanguage;
        } else {
          return false;
        }
      });
  }

  deleteFieldOnFirebaseDocument(id, property) {
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(id)
      .update({
        [property]: this.app2.firestore.FieldValue.delete(),
      });
  }

  createProfile(data) {
    return this.app2.firestore.collection(FirebaseConstants.branding).add({
      firmenname: data.firmenname || '',
      webseite: data.webseite || '',
      companyLogo: data.companyLogo || '',
      colorCode: data.colorCode || '',
      email: data.email || '',
      password: data.password || '',
      created: new Date(),
      status: 'aktiv',
      createdISO: new Date().toISOString(),
      createdISODate: new Date().toISOString().split('T')[0],
      createdGerman: new Date().toLocaleString('de-DE'),
      emailText: data.emailText || '',
      fallbackInterviewId: data.fallbackInterviewId || '',
      interviewFinishedURL: data.interviewFinishedURL || '',
      euMatching: data.euMatching || false,
      minimumMatchingResult: data.minimumMatchingResult || 0,
      sendMatches: data.sendMatches || false,
      chosenCriteria: data.chosenCriteria || [],
      mustHaves: data.mustHaves || [],
      personalizedMessage: data.personalizedMessage,
      dataProtection: data.dataProtection || '',
    });
  }

  getAPIData() {
    return this.getProfile()
      .get()
      .then((snap) => {
        var docs = snap.docs;
        var docLength = docs.length;
        if (docLength > 0) {
          return docs[0].data();
        } else {
          return false;
        }
      });
  }

  saveZvooveAPIKeys(data) {
    return this.getProfile()
      .get()
      .then((snap) => {
        let docs = snap.docs;
        let docLength = docs.length;
        if (docLength > 0) {
          var id = docs[0].id;
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              zvoove: data.zvoove,
              zvooveBewerberApiKey: data.zvooveBewerberApiKey || '',
              zvooveBewerberApiLink: data.zvooveBewerberApiLink || '',
              zvooveStellenApiKey: data.zvooveStellenApiKey || '',
              zvooveStellenApiLink: data.zvooveStellenApiLink || '',
              zvoooveNextLevelApiKey: data.zvoooveNextLevelApiKey || '',
              zvooveNextLevelApiLink: data.zvooveNextLevelApiLink || '',
              zvooveBewerberApiLinkById: data.zvooveBewerberApiLinkById || '',
              zvooveCreateBewerberApiLink:
                data.zvooveCreateBewerberApiLink || '',
              username: data.username || '',
              password: data.password || '',
              AIMatchingType: data.AIMatchingType || '',
              updated: new Date(),
              status: 'aktiv',
            });
        } else {
          return false;
        }
      });
  }

  async saveIntegrationData(app: any) {
    try {
      // Extract appId from app
      const appId = app.appId;

      // Collect data directly from app
      const data: any = {};

      // Since the data is stored directly in app, extract the keys
      app.fields.forEach((field: any) => {
        const key = field.key;
        data[key] = app[key]; // Get the value from app directly
      });

      console.log('Data to save: ', data);

      // Retrieve the branding document ID
      const snap = await this.getProfile().get();
      const docs = snap.docs;

      if (docs.length > 0) {
        const id = docs[0].id;

        // Prepare the update data
        const updateData: any = {
          updated: new Date(),
          status: 'aktiv',
          [appId]: true, // Set the appId field to true
          ...data, // Include all collected fields
        };

        // Update the branding document
        await this.app2.firestore
          .collection(FirebaseConstants.branding)
          .doc(id)
          .update(updateData);

        console.log(`Data for ${appId} saved successfully.`);
      } else {
        console.error('Branding document not found.');
      }
    } catch (error) {
      console.error(`Error saving data for ${app.appId}:`, error);
      throw error; // Rethrow to handle it in integrations.ts
    }
  }

  async saveIntegrationDataAccount(
    app: any,
    accountId: string,
    userId: string,
  ) {
    try {
      // Extract appId from app
      const appId = app.appId;

      // Collect data directly from app
      const data: any = {};

      // Since the data is stored directly in app, extract the keys
      app.fields.forEach((field: any) => {
        const key = field.key;
        data[key] = app[key]; // Get the value from app directly
      });

      console.log('Data to save: ', data);

      // Retrieve the branding document ID
      const snap = await this.getProfile().get();
      const docs = snap.docs;

      if (docs.length > 0) {
        const id = docs[0].id;

        // Prepare the update data
        const updateData: any = {
          updated: new Date(),
          status: 'aktiv',
          ...data, // Include all collected fields
        };

        // Update the branding document
        await this.app2.firestore
          .collection(FirebaseConstants.branding)
          .doc(id)
          .update(updateData);

        console.log(`Data for ${appId} saved successfully.`);
      } else {
        console.error('Branding document not found.');
      }
    } catch (error) {
      console.error(`Error saving data for ${app.appId}:`, error);
      throw error; // Rethrow to handle it in integrations.ts
    }
  }

  saveTalent360APIKeys(data) {
    return this.getProfile()
      .get()
      .then((snap) => {
        let docs = snap.docs;
        let docLength = docs.length;
        if (docLength > 0) {
          var id = docs[0].id;
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              talent360: data.talent360,
              talentClientId: data.talentClientId || '',
              talentClientSecret: data.talentClientSecret || '',
              talentAPIBaseUrl: data.talentAPIBaseUrl || '',
              talentAccessTokenUrl: data.talentAccessTokenUrl || '',
              talentPublicAudience: data.talentPublicAudience || '',
              updated: new Date(),
              status: 'aktiv',
            });
        } else {
          return false;
        }
      });
  }

  saveAiFindConfiguration(data) {
    return this.getProfile()
      .get()
      .then((snap) => {
        let docs = snap.docs;
        let docLength = docs.length;
        if (docLength > 0) {
          var id = docs[0].id;
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              aiFind: data.aiFind || false,
              aiFindApiKey: data.aiFindApiKey || '',
              aiFindHostName: data.aiFindHostName || '',
              aiFindNoteCategory: data.aiFindNoteCategory || '',
              aiFindProcess: data.aiFindProcess || '',
              aiFindProcessMona: data.aiFindProcessMona || '',
              aiFindProcessMonaWorking: data.aiFindProcessMonaWorking || '',
              aiFindProcessMonaDone: data.aiFindProcessMonaDone || '',
            });
        } else {
          return false;
        }

      });
  }

  saveIndexAPIKeys(data) {
    return this.getProfile()
      .get()
      .then((snap) => {
        let docs = snap.docs;
        let docLength = docs.length;
        if (docLength > 0) {
          var id = docs[0].id;
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              index: data.index,
              indexLogin: data.indexLogin || '',
              indexPassword: data.indexPassword || '',
              updated: new Date(),
            });
        } else {
          return false;
        }
      });
  }

  saveZapierAPIKeys(data) {
    return this.getProfile()
      .get()
      .then((snap) => {
        let docs = snap.docs;
        let docLength = docs.length;
        if (docLength > 0) {
          var id = docs[0].id;
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              zapier: data.zapier,
              updated: new Date(),
              status: 'aktiv',
            });
        } else {
          return false;
        }
      });
  }

  saveCustomIntegrationAPIKeys(data) {
    return this.getProfile()
      .get()
      .then((snap) => {
        let docs = snap.docs;
        let docLength = docs.length;
        if (docLength > 0) {
          var id = docs[0].id;
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              customIntegration: data.customIntegration,
              updated: new Date(),
              status: 'aktiv',
            });
        } else {
          return false;
        }
      });
  }

  saveTalentionAPIKeys(data) {
    return this.getProfile()
      .get()
      .then((snap) => {
        let docs = snap.docs;
        let docLength = docs.length;
        if (docLength > 0) {
          var id = docs[0].id;
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              talention: data.talention,
              talentionClientId: data.talentionClientId || '',
              talentionClientSecret: data.talentionClientSecret || '',
              talentionAccountId: data.talentionAccountId || '',
              talentionAccountOption: data.talentionAccountOption || '',
              talentionAccountOptionBranches:
                data.talentionAccountOptionBranches || '',
              talentionMonaStatusEingang: data.talentionMonaStatusEingang || '',
              talentionMonaStatusImInterview:
                data.talentionMonaStatusImInterview || '',
              talentionMonaStatusInterviewAbgeschlossen:
                data.talentionMonaStatusInterviewAbgeschlossen || '',
              talentionMonaStatusProfilErstellt:
                data.talentionMonaStatusProfilErstellt || '',
              talentionMonaStatusProfilVersendet:
                data.talentionMonaStatusProfilVersendet || '',
              AIMatchingType: data.AIMatchingType || '',
              updated: new Date(),
              status: 'aktiv',
            });
        } else {
          return false;
        }
      });
  }

  saveCompleetAPIKeys(data) {
    return this.getProfile()
      .get()
      .then((snap) => {
        let docs = snap.docs;
        let docLength = docs.length;
        if (docLength > 0) {
          var id = docs[0].id;
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              compleet: data.compleet || true,
              compleetAPIKeys: data.compleetAPIKeys || '',
              initiativRow: data.initiativRow || '',
              initiativApiKey: data.initiativApiKey || '',
              updated: new Date(),
              AIMatchingType: data.AIMatchingType || '',
              status: 'aktiv',
            });
        } else {
          return false;
        }
      });
  }

  AddIndexAnzeigen(data) {
    if (data['job-id']) {
      return this.app2.firestore.collection('indexstellenanzeigen').add({
        contantName: data['ad-contact-person'],
        contactEmail: data['ad-contact-person-email'],
        jobOfferText: data['ad-text'],
        companyName: data['company'],
        jobId: data['job-id'],
        lastFound: data['last-found'],
        location: data['location'],
        output: data['output'],
        source: data['source'],
        adprice: data['ad-price'],
        language: data['ad-language'],
        street: data['street'],
        zip: data['zip'],
        city: data['city'],
        url: data['doc-link-txt'],
        streetOnly: data['street-only'],
        houseNumber: data['house-number'],
        created: new Date(),
        status: 'aktiv',
        createdISO: new Date().toISOString(),
        createdISODate: new Date().toISOString().split('T')[0],
      });
    }
  }

  updateApplicantCVQualifications(id, data) {
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(id)
      .update({
        cvQualifications: data,
        cvAnalyzed: true,
        CVcreated: new Date(),
        status: 'aktiv',
        CVcreatedISO: new Date().toISOString(),
        CVcreatedISODate: new Date().toISOString().split('T')[0],
        CVcreatedGerman: new Date().toLocaleString('de-DE'),
      });
  }

  updateIndexAnzeigen(id, data) {
    return this.app2.firestore
      .collection('indexstellenanzeigen')
      .doc(id)
      .update({
        contantName: data['ad-contact-person'],
        contactEmail: data['ad-contact-person-email'],
        jobOfferText: data['ad-text'],
        companyName: data['company'],
        jobId: data['job-id'],
        lastFound: data['last-found'],
        location: data['location'],
        output: data['output'],
        source: data['source'],
        adprice: data['ad-price'],
        language: data['ad-language'],
        street: data['street'],
        zip: data['zip'],
        city: data['city'],
        streetOnly: data['street-only'],
        houseNumber: data['house-number'],
        url: data['doc-link-txt'],
        created: new Date(),
        status: 'aktiv',
        createdISO: new Date().toISOString(),
        createdISODate: new Date().toISOString().split('T')[0],
      });
  }

  updateIndexAnzeigenAI(id, data) {
    return this.app2.firestore
      .collection('indexstellenanzeigen')
      .doc(id)
      .update({
        jobOfferFeedback: data,
      });
  }

  getIndexAnzeigen(): firebase.firestore.CollectionReference {
    return this.app2.firestore.collection('indexstellenanzeigen');
  }

  getZvooveJobsApiKey(): Promise<string> {
    return this.getProfile()
      .get()
      .then((snap) => {
        let docs = snap.docs;
        let docLength = docs.length;
        if (docLength > 0) {
          return docs[0].data().zvooveStellenApiKey;
        } else {
          return '';
        }
      });
  }

  getZvooveJobsApiLink(): Promise<string> {
    return this.getProfile()
      .get()
      .then((snap) => {
        var docs = snap.docs;
        var docLength = docs.length;
        if (docLength > 0) {
          return docs[0].data().zvooveStellenApiLink;
        } else {
          return '';
        }
      });
  }

  getZvooveBewerberApiKey(): Promise<string> {
    return this.getProfile()
      .get()
      .then((snap) => {
        var docs = snap.docs;
        var docLength = docs.length;
        if (docLength > 0) {
          return docs[0].data().zvooveBewerberApiKey;
        } else {
          return '';
        }
      });
  }

  getZvooveBewerberApiLinkById(): Promise<string> {
    return this.getProfile()
      .get()
      .then((snap) => {
        var docs = snap.docs;
        var docLength = docs.length;
        if (docLength > 0) {
          return docs[0].data().zvooveBewerberApiLinkById;
        } else {
          return '';
        }
      });
  }

  getZvooveBewerberApiLink(): Promise<string> {
    return this.getProfile()
      .get()
      .then((snap) => {
        var docs = snap.docs;
        var docLength = docs.length;
        if (docLength > 0) {
          return docs[0].data().zvooveBewerberApiLink;
        } else {
          return '';
        }
      });
  }

  getZvooveCreateBewerberApiLink(): Promise<string> {
    return this.getProfile()
      .get()
      .then((snap) => {
        var docs = snap.docs;
        var docLength = docs.length;
        if (docLength > 0) {
          return docs[0].data().zvooveCreateBewerberApiLink;
        } else {
          return '';
        }
      });
  }

  getZvooveMandantUuID(): Promise<string> {
    return this.getProfile()
      .get()
      .then((snap) => {
        var docs = snap.docs;
        var docLength = docs.length;
        if (docLength > 0) {
          return docs[0].data().zvooveMandantUuID;
        } else {
          return '';
        }
      });
  }

  updateFallbackJobOffer(id) {
    this.getJobOffersDetail(id).update({
      isFallback: true,
    });
    this.getJobOffers()
      .get()
      .then((snap) => {
        snap.forEach((doc) => {
          if (doc.id != id) {
            this.getJobOffersDetail(doc.id).update({
              isFallback: false,
            });
          }
        });
      });
  }

  retreiveMONAIMAPAccounts() {
    return this.getProfile()
      .get()
      .then((snap) => {
        var docs = snap.docs;
        var docLength = docs.length;
        if (docLength > 0) {
          return docs[0].data().imapArray;
        } else {
          return [];
        }
      });
  }

  retreiveMONASMTPAccounts() {
    return this.getProfile()
      .get()
      .then((snap) => {
        var docs = snap.docs;
        var docLength = docs.length;
        if (docLength > 0) {
          return docs[0].data().smtpArray;
        } else {
          return [];
        }
      });
  }

  saveMONAIMAPAccountWithAttachedWorkflow(email, password, workflow) {
    let workflowId = workflow.id;
    return this.getProfile()
      .get()
      .then((snap) => {
        var docs = snap.docs;
        var docLength = docs.length;
        let imapArray = [];
        if (docLength > 0) {
          var id = docs[0].id;
          if (docs[0].data().imapArray) {
            imapArray = docs[0].data().imapArray;
          }
          console.log('imapArray: ', imapArray);

          // check if email already exists
          let emailExists = false;
          imapArray.forEach((item) => {
            if (item.email == email.email) {
              emailExists = true;
            }
          });

          if (emailExists) {
            // only update the workflows inside the array element, not the array itself
            imapArray.forEach((item) => {
              if (item.email == email.email) {
                item.workflow = workflow;
              }
            });
            return this.app2.firestore
              .collection(FirebaseConstants.branding)
              .doc(id)
              .update({
                imapArray: imapArray,
              });
          }
          if (imapArray.length > 0) {
            let item = {
              email: email,
              password: password,
              host: email.host || 'mail.mona-ai.online',
              tls: email.tls || true,
              port: email.port || 993,
              timeRange: email.timeRange || '1day',
              authTimeout: email.authTimeout || 30000,
              workflowId: workflowId,
            };
            imapArray.push(item);
          } else {
            imapArray = [
              {
                email: email,
                password: password,
                host: email.host || 'mail.mona-ai.online',
                tls: email.tls || true,
                port: email.port || 993,
                timeRange: email.timeRange || '1day',
                authTimeout: email.authTimeout || 30000,
                workflowId: workflowId,
              },
            ];
          }
          console.log('imapArray: ', imapArray);
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              imapArray: imapArray,
            });
        } else {
          return false;
        }
      });
  }

  saveMONASMTPAccountWithAttachedWorkflow(email, workflow) {
    let workflowId = workflow.id;
    return this.getProfile()
      .get()
      .then((snap) => {
        var docs = snap.docs;
        var docLength = docs.length;
        let smtpArray = [];
        if (docLength > 0) {
          var id = docs[0].id;
          if (docs[0].data().smtpArray) {
            smtpArray = docs[0].data().smtpArray;
          }
          console.log('smtpArray: ', smtpArray);

          // check if email already exists
          let emailExists = false;
          smtpArray.forEach((item) => {
            if (item.email == email.email) {
              emailExists = true;
            }
          });

          if (emailExists) {
            // only update the workflows inside the array element, not the array itself
            smtpArray.forEach((item) => {
              if (item.email == email.email) {
                item.workflow = workflow;
              }
            });
            return this.app2.firestore
              .collection(FirebaseConstants.branding)
              .doc(id)
              .update({
                smtpArray: smtpArray,
              });
          }
          if (smtpArray.length > 0) {
            let item = {
              email: email.email,
              password: email.password,
              host: email.host || 'mail.mona-ai.online',
              tls: email.tls || true,
              port: email.port || 993,
              timeRange: email.timeRange || '1day',
              authTimeout: email.authTimeout || 30000,
              workflowId: workflowId,
            };
            smtpArray.push(item);
          } else {
            smtpArray = [
              {
                email: email.email,
                password: email.password,
                host: email.host || 'mail.mona-ai.online',
                tls: email.tls || true,
                port: email.port || 993,
                timeRange: email.timeRange || '1day',
                authTimeout: email.authTimeout || 30000,
                workflowId: workflowId,
              },
            ];
          }
          console.log('smtpArray: ', smtpArray);
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              smtpArray: smtpArray,
            });
        } else {
          return false;
        }
      });
  }

  saveEmailCredentials(data) {
    return this.getProfile()
      .get()
      .then((snap) => {
        var docs = snap.docs;
        var docLength = docs.length;
        if (docLength > 0) {
          var id = docs[0].id;
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              email: data.email || '',
              password: data.password || '',
              updated: new Date(),
              status: 'aktiv',
            });
        } else {
          return false;
        }
      });
  }

  deleteMONAIMAPAccount(email) {
    return this.getProfile()
      .get()
      .then((snap) => {
        var docs = snap.docs;
        var docLength = docs.length;
        if (docLength > 0) {
          var id = docs[0].id;
          var imapArray = docs[0].data().imapArray;
          var newIMAPArray = imapArray.filter((item) => {
            return item.email != email;
          });
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              imapArray: newIMAPArray,
            });
        } else {
          return false;
        }
      });
  }

  deleteMONASMTPAccount(email) {
    return this.getProfile()
      .get()
      .then((snap) => {
        var docs = snap.docs;
        var docLength = docs.length;
        if (docLength > 0) {
          var id = docs[0].id;
          var smtpArray = docs[0].data().smtpArray;
          var newSMTPArray = smtpArray.filter((item) => {
            return item.email != email;
          });
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              smtpArray: newSMTPArray,
            });
        } else {
          return false;
        }
      });
  }

  createProfileEmail(
    email,
    password,
    host?,
    tls?,
    port?,
    timeRange?,
    authTimeout?,
    type?,
  ) {
    if (type == 'imap') {
      return this.getProfile()
        .get()
        .then((snap) => {
          var docs = snap.docs;
          var docLength = docs.length;
          let imapArray = [];
          if (docLength > 0) {
            var id = docs[0].id;
            if (docs[0].data().imapArray) {
              imapArray = docs[0].data().imapArray;
            }
            // check if email already exists
            let emailExists = false;
            imapArray.forEach((item) => {
              if (item.email == email) {
                emailExists = true;
              }
            });

            if (emailExists) {
              return false;
            }

            if (imapArray.length > 0) {
              let item = {
                email: email,
                password: password,
                host: host || 'mail.mona-ai.online',
                tls: tls || true,
                port: port || 993,
                timeRange: timeRange || '1day',
                authTimeout: authTimeout || 30000,
              };
              imapArray.push(item);
            } else {
              imapArray = [
                {
                  email: email,
                  password: password,
                  host: host || 'mail.mona-ai.online',
                  tls: tls || true,
                  port: port || 993,
                  timeRange: timeRange || '1day',
                  authTimeout: authTimeout || 30000,
                },
              ];
            }
            console.log('imapArray: ', imapArray);
            return this.app2.firestore
              .collection(FirebaseConstants.branding)
              .doc(id)
              .update({
                imapArray: imapArray,
              });
          } else {
            return false;
          }
        });
    } else if (type == 'smtp') {
      return this.getProfile()
        .get()
        .then((snap) => {
          var docs = snap.docs;
          var docLength = docs.length;
          if (docLength > 0) {
            var id = docs[0].id;
            return this.app2.firestore
              .collection(FirebaseConstants.branding)
              .doc(id)
              .update({
                smtpEmail: email || '',
                smtpPassword: password || '',
                smtpHost: host || 'mail.mona-ai.online',
                smtpTls: tls || true,
                smtpPort: port || 993,
                smtpTimeRange: timeRange || '1day',
                smtpAuthTimeout: authTimeout || 30000,
              });
          } else {
            return false;
          }
        });
    }
  }

  updateProfileSMTP(
    email,
    password,
    host?,
    tls?,
    port?,
    timeRange?,
    authTimeout?,
  ) {
    // get profile and add the email into the array of smtpArray
    return this.getProfile()
      .get()
      .then((snap) => {
        var docs = snap.docs;
        var docLength = docs.length;
        let smtpArray = [];
        if (docLength > 0) {
          var id = docs[0].id;
          if (docs[0].data().smtpArray) {
            smtpArray = docs[0].data().smtpArray;
          }
          // check if email already exists
          let emailExists = false;
          let passwordExists = false;
          smtpArray.forEach((item) => {
            if (item.email == email) {
              emailExists = true;
            }
            if (item.password == password) {
              passwordExists = true;
            }
          });

          if (emailExists && passwordExists) {
            return false;
          }

          if (smtpArray.length > 0) {
            let item = {
              email: email,
              password: password,
              host: host || 'mail.mona-ai.online',
              tls: tls || true,
              port: port || 993,
              timeRange: timeRange || '1day',
              authTimeout: authTimeout || 30000,
            };
            smtpArray.push(item);
          } else {
            smtpArray = [
              {
                email: email,
                password: password,
                host: host || 'mail.mona-ai.online',
                tls: tls || true,
                port: port || 993,
                timeRange: timeRange || '1day',
                authTimeout: authTimeout || 30000,
              },
            ];
          }
          console.log('smtpArray: ', smtpArray);
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              smtpArray: smtpArray,
            });
        } else {
          return false;
        }
      });
  }

  updateProfileIMAP(
    email,
    password,
    host?,
    tls?,
    port?,
    timeRange?,
    authTimeout?,
  ) {
    // get profile and add the email into the array of imaparray
    return this.getProfile()
      .get()
      .then((snap) => {
        var docs = snap.docs;
        var docLength = docs.length;
        let imapArray = [];
        if (docLength > 0) {
          var id = docs[0].id;
          if (docs[0].data().imapArray) {
            imapArray = docs[0].data().imapArray;
          }
          // check if email already exists
          let emailExists = false;
          let passwordExists = false;
          imapArray.forEach((item) => {
            if (item.email == email) {
              emailExists = true;
            }
            if (item.password == password) {
              passwordExists = true;
            }
          });

          if (emailExists && passwordExists) {
            return false;
          }

          if (imapArray.length > 0) {
            let item = {
              email: email,
              password: password,
              host: host || 'mail.mona-ai.online',
              tls: tls || true,
              port: port || 993,
              timeRange: timeRange || '1day',
              authTimeout: authTimeout || 30000,
            };
            imapArray.push(item);
          } else {
            imapArray = [
              {
                email: email,
                password: password,
                host: host || 'mail.mona-ai.online',
                tls: tls || true,
                port: port || 993,
                timeRange: timeRange || '1day',
                authTimeout: authTimeout || 30000,
              },
            ];
          }
          console.log('imapArray: ', imapArray);
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              imapArray: imapArray,
            });
        } else {
          return false;
        }
      });
  }

  async updateProfile(data) {
    let isNewLogoUploaded = data.isNewLogoUploaded || false;

    if (isNewLogoUploaded) {
      let newName = `${new Date().getTime()}-companyLogo.png`;
      let storageRef: AngularFireStorageReference = this.customerStorage.ref(
        `/company/${newName}`,
      );
      let base64 = data.companyLogo;

      // Convert base64 to Blob
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'image/png' });

      // Upload to Firebase Storage
      const uploadTaskSnapshot = await storageRef.put(blob);
      const publicUrl = await uploadTaskSnapshot.ref.getDownloadURL();

      data.companyLogo = publicUrl; // Update the data with the new URL

    }
    this.getProfile()
      .get().then((snap) => {
        const docs = snap.docs;
        this.app2.firestore
          .collection(FirebaseConstants.branding)
          .doc(docs[0].id)
          .update({
            firmenname: data.firmenname || '',
            webseite: data.webseite || '',
            companyLogo: data.companyLogo || '',
            colorCode: data.colorCode || '',
            email: data.email || '',
            created: new Date(),
            status: 'aktiv',
            createdISO: new Date().toISOString(),
            createdISODate: new Date().toISOString().split('T')[0],
            createdGerman: new Date().toLocaleString('de-DE'),
            standorte: data.standorte || [],
            zvooveBewerberApiKey: data.zvooveBewerberApiKey || '',
            zvooveBewerberApiLink: data.zvooveBewerberApiLink || '',
            zvooveStellenApiKey: data.zvooveStellenApiKey || '',
            zvooveStellenApiLink: data.zvooveStellenApiLink || '',
            zvooveBewerberApiLinkById:
              data.zvooveBewerberApiLinkById || '',
            zvooveCreateBewerberApiLink:
              data.zvooveCreateBewerberApiLink || '',
            zvooveMandantUuID: data.zvooveMandantUuID || '',
            fallbackInterviewId: data.fallbackInterviewId || '',
            interviewFinishedURL: data.interviewFinishedURL || '',
            chosenCriteria: data.chosenCriteria || [],
            euMatching: data.euMatching || false,
            minimumMatchingResult: data.minimumMatchingResult || 0,
            sendMatches: data.sendMatches || false,
            mustHaves: data.mustHaves || [],
            isZvoove: data.isZvoove || false,
            emailText: data.emailText || '',
            smsText: data.smsText || '',
            autoTranslateInviteMessagesBool:
              data.autoTranslateInviteMessagesBool || false,
            betreffText: data.betreffText || '',
            personalizedMessage: data.personalizedMessage || '',
            dataProtection: data.dataProtection || '',
            platformLanguage: data.platformLanguage || '',
            platformMatchingType: data.platformMatchingType || {},
            platformMatchingTypeSpecific:
              data.platformMatchingTypeSpecific || {},
          }).then(() => {
            return;
          });
      });
    // );

    // }),
    // );
    // }
  }
  createaApplicantProfile(form) {
    return this.app2.firestore.collection('applicantProfile').add({
      form: form,
      email: form.email,
      vorname: form.vorname || '',
      language: form.language,
      nachname: form.nachname || '',
      jobTitle: form.jobTitle || '',
      jobpost: form.jobTitle || '',
      codingScore: form.codingScore || '',
      codingTitle: form.challengeTitle || '',
      codingChallenge: form.codingChallenge || {
        checked: false,
        description: '',
        language: '',
        level: '',
        name: '',
        type: '',
        url: '',
      },
      bewerberID: form.id,
      created: new Date(),
      status: 'aktiv',
      createdISO: new Date().toISOString(),
      createdISODate: new Date().toISOString().split('T')[0],
      createdGerman: new Date().toLocaleString('de-DE'),
    });
  }

  updateApplicantProfile(id, form) {
    return this.app2.firestore.collection('applicantProfile').doc(id).update({
      form: form,
    });
  }

  addApplicant(applicant) {
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .add(applicant);
  }

  getEmailApplicants() {
    return this.app2.firestore.collection(FirebaseConstants.emailapplicants);
  }

  createZvooveApplicant(data) {
    this.getEmailApplicants()
      .where('uid', '==', data.uid)
      .get()
      .then(async (snap) => {
        if (snap.docs.length == 0) {
          const apiKey = await this.getZvooveBewerberApiKey();
          const apiLink = await this.getZvooveBewerberApiLinkById();
          let body = {
            apiKey: apiKey,
            apiLink: apiLink,
            applicantId: data.uid,
          };
          return this.http
            .post(
              'https://us-central1-mona-ai-pwa-firebase.cloudfunctions.net/zvoove-applicants-by-id',
              body,
            )
            .subscribe((res: any) => {
              console.log(res);
              this.getEmailApplicants().add({
                created: new Date(),
                email: data.email || '',
                vorname: data.name || '',
                nachname: data.surename || '',
                telefonnummer: data.mobile || data.phone || '',
                uid: data.uid || '',
                quelle: 'zvoove',
                jobUid:
                  res.Bewerbungen.length > 0
                    ? res.Bewerbungen[0].Stelle.ObjectUuid
                    : '',
                isInZvoove: true,
              });
            });
        }
      });
  }

  getReports() {
    return this.app2.firestore.collection('reporting');
  }

  returnChatHistory() {
    return this.app2.firestore.collection('MONARetrieval01');
  }

  addMONAChatMessage(message) {
    let userId = this.authService.returnUserId() || '';
    let accountId = this.authService.returnAccountId() || '';
    let db_level = 'sub';
    if (accountId == '') {
      db_level = 'top';
    }
    console.log('message', message);
    console.log('userId', userId);
    console.log('accountId', accountId);
    return this.app2.firestore.collection('MONARetrieval01').add({
      prompt: message.content || '',
      sender: message.sender,
      session_id: message.session_id,
      user_input: message.user_input,
      document_link: message.document_link,
      document_name: message.document_name,
      allowed_tools: message.allowed_tools,
      current_date: message.current_date,
      description: message.description,
      language_code: message.language_code,
      user_id: userId,
      db_level: db_level,
      account_id: accountId,
      created: new Date(),
      createTime: new Date(),
      createdISO: new Date().toISOString(),
    });
  }

  addFormattingAIBefore(message) {
    return this.app2.firestore.collection('MONARetrieval01').add({
      prompt: message.content || '',
      sender: message.sender,
      tool: '',
      created: new Date(),
      createTime: new Date(),
      createdISO: new Date().toISOString(),
    });
  }

  deleteMONAChatMessage(messageid) {
    return this.app2.firestore.collection('MONARetrieval01').delete(messageid);
  }

  updateChatMessageFeedback(id, feedback) {
    return this.app2.firestore.collection('MONARetrieval01').doc(id).update({
      feedback: feedback,
    });
  }

  // addMONAChatMessage(message, monaTool) {
  //   console.log("message", message);
  //   return this.app2.firestore.collection("generate").add({
  //     prompt: message.content || "",
  //     sender: message.sender,
  //     tool: monaTool
  //   })
  // }

  // addFormattingAIBefore(message) {
  //   return this.app2.firestore.collection("generate").add({
  //     prompt: message.content || "",
  //     sender: message.sender,
  //     tool: ""
  //   })
  // }

  // deleteMONAChatMessage(messageid) {
  //   return this.app2.firestore.collection("generate").delete(messageid)
  // }
  //

  AddJobs(profile) {
    return this.app2.firestore
      .collection('applicantsToCall')
      .add({
        profile: profile,
        jobId: profile.jobId,
        phoneNumber: profile.mobiltelefon || profile.telefon || '',
        email: profile.email,
        telefonnummer: profile.telefon,
        mobilnummer: profile.mobiltelefon,
        jobOfferWorkflow: profile.jobOfferWorkflow,
        firstName: profile.vorname,
        lastName: profile.nachname,
        vorname: profile.vorname,
        nachname: profile.nachname,
        jobTitle: profile.jobTitle,
        quelle: 'intern',
        status: 'new',
        created: new Date(),
        createdGerman: new Date().toLocaleDateString('de-DE'),
        createdISO: new Date().toISOString(),
        createdISODate: new Date().toISOString().split('T')[0],
        timestamp: new Date().getTime(),
      })
      .then(() => { })
      .catch((err) => {
        if (profile.email) {
          this.alertErrorUpload(profile.email);
        } else if (profile.mobiltelefon || profile.telefon) {
          this.alertErrorUpload(profile.mobiltelefon || profile.telefon);
        } else if (profile.vorname || profile.nachname) {
          this.alertErrorUpload(profile.vorname || profile.nachname);
        } else {
          this.alertErrorUpload('unknown');
        }
      });
  }

  /*
    * This function is used to create a new applicant.
    */
  async createNewApplicant(newApplicantData) {
    return await this.app2.firestore.collection(FirebaseConstants.applicants).add(newApplicantData)

  }

  createApplicant(form) {
    this.getApplicants()
      .orderBy('id', 'desc')
      .get()
      .then((snap) => {
        if (snap.docs) {
          var id = String(Number(snap.docs[0].id) + 1);
          return this.app2.firestore
            .collection(FirebaseConstants.applicants)
            .doc(id)
            .set({
              form: form,
              email: form.email,
              id: id,
            });
        } else {
          var id = '1001';
          return this.app2.firestore
            .collection(FirebaseConstants.applicants)
            .doc(id)
            .set({
              form: form,
              email: form.email,
              id: id,
            });
        }
      })
      .catch((err) => {
        var id = 'no id';
        return id;
      });
  }

  getApplicantEditingData(id) {
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(id)
      .get();
  }

  async updateApplicantForm(id, form) {
    console.log(form);
    form.Wohnort = {
      city: form.wohnort || '',
      hausnummer: form.hausnummer || '',
      strasse: form.strasse || '',
      postleitzahl: form.postleitzahl || '',
    }
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(id)
      .update({
        Wohnort: form.Wohnort,
        vorname: form.vorname || '',
        nachname: form.nachname || '',
        geburtsname: form.geburtsname || '',
        land: form.land || '',
        geburtsdatum: form.geburtsdatum || '',
        sprache: form.sprache || [''],
        languages: form.languages || [''],
        strasse: form.strasse || '',
        hausnummer: form.hausnummer || [''],
        postleitzahl: form.postleitzahl || '',
        wohnort: form.wohnort || '',
        geburtsland: form.geburtsland || '',
        geburtsort: form.geburtsort || '',
        staatsangehoerigkeit: form.staatsangehoerigkeit || '',
        telefonnummer: form.telefonnummer || '',
        handynummer: form.handynummer || '',
        email: form.email || '',
        sentSMS: form.sentSMS || false,
        sentPhonecall: form.sentPhonecall || false,
        sentEmail: form.sentEmail || false,
        updated: { date: new Date(), updatedBy: this.authService.returnUser() },
        notes: form.notes || '',
        qualifications: form.qualifications || '',
        unternehmen: form.unternehmen || '',
        customFields: form.customFields || [''],
        experience: form.experience || '',
        mobilnummer: form.mobilnummer || '',
        nationalitaet: form.staatsangehoerigkeit || '',
      });
  }

  updateApplicantMONAFeedback(id, feedback) {
    console.log(feedback);
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(id)
      .update({
        MONAFeedback: feedback,
      });
  }

  updateApplicantMatches(id, feedback) {
    console.log(feedback);
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(id)
      .update({
        AIMatches: feedback,
      });
  }

  updateApplicantResumeFeedback(id, feedback) {
    console.log(feedback);
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(id)
      .update({
        ResumeFeedback: feedback,
      });
  }

  updateApplicantInformation(id, pn, arbeit, form) {
    console.log(form);
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(id)
      .update({
        status: 'mitarbeiter',
        personalnummer: pn,
        Personalnummer: pn,
        Arbeit: arbeit,
        arbeit: arbeit,
        form: form,
      });
  }

  getFirestoreDate(date) {
    // Check if 'date' is an instance of Date and is valid
    if (!(date instanceof Date) || isNaN(date.getTime())) {
      console.error('Invalid date object:', date);
      // Handle the error appropriately
      return; // or throw an error
    }

    // If valid, convert to Firestore Timestamp
    const firestoreDate = firebase.firestore.Timestamp.fromDate(date);
    return firestoreDate;
  }

  updateApplicantStatus(id, status) {
    console.log('----------- status changed to: ' + status + ' ----------- ');
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(id)
      .update({
        status: status,
      });
  }

  updateApplicantWithArray(id, data) {
    console.log(data);
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(id)
      .update({
        workflowArray: data,
      });
  }

  updateFullApplicantObjectWithLogs(id, logs) {
    console.log(logs);
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(id)
      .update({
        logs: logs,
      });
  }

  updateApplicant(id: string, data: Partial<any>): Promise<void> {
    return this.app2.firestore
      .collection('applicants')
      .doc(id)
      .update(data)
      .then(() => {
        console.log(`Applicant ${id} successfully updated.`);
      })
      .catch((error) => {
        console.error(`Error updating applicant ${id}:`, error);
        throw error; // Re-throw the error after logging
      });
  }

  getApplicants(): firebase.firestore.CollectionReference {
    return this.app2.firestore.collection(FirebaseConstants.applicants);
  }

  deleteApplicantField(id: string, field: string): Promise<void> {
    console.log(
      `----------- Deleting field '${field}' for applicant ID: ${id} ----------- `,
    );
    const updateData: any = {};
    updateData[field] = firebase.firestore.FieldValue.delete();
    return this.updateApplicant(id, updateData);
  }

  updateCalendlyLink(id: string, calendlyLink: string): Promise<void> {
    console.log(
      `----------- Updating calendly link for applicant ID: ${id} -----------`,
    );
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(id)
      .update({
        calendlyLink: calendlyLink,
      });
  }

  updateJobOfferWorkflowInApplicants(
    id: string,
    jobOfferWorkflow: string,
  ): Promise<void> {
    console.log(
      `----------- Updating job offer workflow for applicant ID: ${id} ----------- `,
    );
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(id)
      .update({
        jobOfferWorkflow: jobOfferWorkflow,
      });
  }

  async deleteLastLog(id: string, currentLogs: any[]): Promise<void> {
    if (Array.isArray(currentLogs) && currentLogs.length > 0) {
      const updatedLogs = currentLogs.slice(0, -1);
      console.log(
        `----------- Deleting last log for applicant ID: ${id} ----------- `,
      );
      await this.updateApplicant(id, { logs: updatedLogs });
    } else {
      console.log(
        `----------- No logs to delete for applicant ID: ${id} ----------- `,
      );
    }
  }

  addLogToApplicant(id: string, log: any): Promise<void> {
    console.log(`----------- Adding log to applicant ID: ${id} ----------- `);
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(id)
      .update({
        logs: firebase.firestore.FieldValue.arrayUnion(log),
      });
  }

  async getApplicantById(applicantId) {
    if (applicantId == null || applicantId == undefined || applicantId === '') {
      return null;
    }
    let docRef = await this.app2.firestore.collection(FirebaseConstants.applicants).doc(applicantId);
    if (docRef) {
      return docRef.get().then((doc) => {
        if (doc.exists) {
          let data = doc.data();
          data.id = doc.id;
          data.applicantId = doc.id;
          return data;
        } else {
          console.log("No such document!");
          return null;
        }
      }).catch((error) => {
        console.error("Error getting document:", error);
        return null;
      });
    }
    return null;
  }

  async getApplicantsWithCreated() {
    const snapshot = await this.createdQuery.get();
    // iterate docs and get data
    const applicants = snapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        id: doc.id,
        ...data,
      };
    });
    // TODO after change to pull data from API
    return applicants;
  }

  // async getMatchesFromAPI() {
  //   return this.http.post(
  //     'https://europe-west3-mona-ai-pwa-firebase.cloudfunctions.net/database',
  //     {
  //       endpoint: 'getMatchesFromDatabaseForPlatform',
  //       apiKey: 'asd',
  //       uid: this.authService.returnUserId(),
  //       platform: 'MONA',
  //       permission: 'readData',
  //     },
  //     {
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //     },
  //   ).toPromise()
  //   .then((response: any) => {
  //     console.log('Response from API:', response);
  //     return response; // Return the response from the API
  //   });
  //   // TODO after change to pull data from API
  //   return applicants;
  // }

  async getMatchesFromAPI(): Promise<{
    total: number;
    count: number;
    data: { emailsToBeSent: any[] };
    error?: string;
  }> {
    let allMatches: any[] = [];
    let hasMore = true;
    let paginationToken: string | null = null;

    try {
      while (hasMore) {
        const requestBody: any = {
          endpoint: 'getMatchesFromDatabaseForPlatform',
          apiKey: 'asd',
          uid: this.authService.returnUserId(),
          platform: 'MONA',
          permission: 'readData',
          ...(paginationToken && { paginationToken })
        };

        const response: any = await this.http
          .post(
            'https://europe-west3-mona-ai-pwa-firebase.cloudfunctions.net/database',
            requestBody,
            {
              headers: {
                'Content-Type': 'application/json',
                'Accept-Encoding': 'gzip, deflate',
              },
            }
          )
          .toPromise();

        console.log('API Response:', response);

        if (response?.data?.emailsToBeSent) {
          allMatches.push(...response.data.emailsToBeSent);
          paginationToken = response.pagination?.nextPageToken || null;
          hasMore = paginationToken !== null;

          if (allMatches.length >= 5000) {
            console.warn(
              'Reached maximum limit of 5000 matches, stopping pagination'
            );
            hasMore = false;
          }
        } else {
          console.log('No more data or invalid response structure');
          hasMore = false;
        }
      }

      const result = {
        total: allMatches.length,
        count: allMatches.length,
        data: { emailsToBeSent: allMatches },
      };

      console.log('Final aggregated result:', {
        totalMatches: result.total,
        pagesProcessed: Math.ceil(allMatches.length / 250),
      });

      return result;
    } catch (error: any) {
      console.error('Error fetching matches:', error);
      // Instead of throwing, always return a well-formed result with an error message
      return {
        total: 0,
        count: 0,
        data: { emailsToBeSent: [] },
        error: error?.message ?? 'Unknown error',
      };
    }
  }


  // async getMatchesFromAPI() {
  //   let allMatches = [];
  //   let hasMore = true;
  //   let paginationToken = null;

  //   try {
  //     // Keep fetching pages until we have all the data
  //     while (hasMore) {
  //       const requestBody: any = {
  //         endpoint: 'getMatchesFromDatabaseForPlatform',
  //         apiKey: 'asd',
  //         uid: this.authService.returnUserId(),
  //         platform: 'MONA',
  //         permission: 'readData'
  //       };

  //       // Add pagination token if we have one
  //       if (paginationToken) {
  //         requestBody.paginationToken = paginationToken;
  //       }

  //       const response: any = await this.http.post(
  //         'https://europe-west3-mona-ai-pwa-firebase.cloudfunctions.net/database',
  //         requestBody,
  //         {
  //           headers: {
  //             'Content-Type': 'application/json',
  //             'Accept-Encoding': 'gzip, deflate'
  //           }
  //         }
  //       ).toPromise();

  //       console.log('API Response:', response);

  //       // Check if we got valid data
  //       if (response && response.data && response.data.emailsToBeSent) {
  //         // Add this page of data to our collection
  //         allMatches = [...allMatches, ...response.data.emailsToBeSent];

  //         // Check if there are more pages to fetch
  //         // Your API returns nextPageToken in pagination object
  //         paginationToken = response.pagination?.nextPageToken || null;
  //         hasMore = paginationToken !== null;

  //         // Safety check to prevent infinite loops
  //         if (allMatches.length >= 5000) { // Increased limit since we're fetching 250 per page
  //           console.warn('Reached maximum limit of 5000 matches, stopping pagination');
  //           hasMore = false;
  //         }
  //       } else {
  //         console.log('No more data or invalid response structure');
  //         hasMore = false;
  //       }
  //     }

  //     // Return data using the total from the API response (if available from last call)
  //     // or fall back to the actual count we collected
  //     const result = {
  //       total: allMatches.length, // You could also use response.total from the last response
  //       count: allMatches.length,
  //       data: { emailsToBeSent: allMatches }
  //     };

  //     console.log('Final aggregated result:', {
  //       totalMatches: result.total,
  //       pagesProcessed: Math.ceil(allMatches.length / 250) // Now 250 per page
  //     });

  //     return result;

  //   } catch (error) {
  //     console.error('Error fetching matches:', error);
  //     throw error;
  //   }
  // }

  // async getApplicantsWithCreatedFromAPI() {
  //   // Define smaller page size to avoid response size limitations
  //   const pageSize = 100;
  //   let allApplicants = [];
  //   let hasMore = true;
  //   let cursor = null;

  //   try {
  //     // Keep fetching pages until we have all the data
  //     while (hasMore) {
  //       const response: any = await this.http.post(
  //         'https://europe-west3-mona-ai-pwa-firebase.cloudfunctions.net/database',
  //         {
  //           endpoint: 'getApplicantsFromDatabaseForPlatform',
  //           apiKey: 'asd',
  //           uid: this.authService.returnUserId(),
  //           platform: 'MONA',
  //           permission: 'readApplicants',
  //           // Add pagination parameters
  //           pageSize: pageSize,
  //           cursor: cursor
  //         },
  //         {
  //           headers: {
  //             'Content-Type': 'application/json',
  //             'Accept-Encoding': 'gzip, deflate' // Support compression
  //           }
  //         }
  //       ).toPromise();

  //       // Check if we got valid data
  //       if (response && response.data) {
  //         // Add this page of data to our collection
  //         allApplicants = [...allApplicants, ...response.data];

  //         // Check if there are more pages to fetch
  //         hasMore = response.pagination?.hasMore || false;
  //         cursor = response.pagination?.nextCursor || null;

  //         // Safety check to prevent infinite loops
  //         if (!cursor || allApplicants.length >= 2500) {
  //           hasMore = false;
  //         }
  //       } else {
  //         hasMore = false;
  //       }
  //     }

  //     // Return data in the same format as the original API
  //     const result = {
  //       data: allApplicants,
  //       count: allApplicants.length
  //     };

  //     console.log('Response from API:', result);
  //     return result;

  //   } catch (error) {
  //     console.error('Error fetching applicants:', error);
  //     throw error;
  //   }
  // }

  // async getSalesCorrespondenceFromDatabaseFromAPI() {
  //   // Define smaller page size to avoid response size limitations
  //   const pageSize = 100;
  //   let allCorrespondence = [];
  //   let hasMore = true;
  //   let cursor = null;

  //   try {
  //     // Keep fetching pages until we have all the data
  //     while (hasMore) {
  //       const response: any = await this.http.post(
  //         'https://europe-west3-mona-ai-pwa-firebase.cloudfunctions.net/database',
  //         {
  //           endpoint: 'getSalesCorrespondenceFromDatabase',
  //           apiKey: 'asd',
  //           uid: this.authService.returnUserId(),
  //           platform: 'MONA',
  //           permission: 'readData',
  //           // Add pagination parameters
  //           pageSize: pageSize,
  //           cursor: cursor
  //         },
  //         {
  //           headers: {
  //             'Content-Type': 'application/json',
  //             'Accept-Encoding': 'gzip, deflate' // Support compression
  //           }
  //         }
  //       ).toPromise();

  //       // Check if we got valid data
  //       if (response && response.data) {
  //         // Add this page of data to our collection
  //         allCorrespondence = [...allCorrespondence, ...response.data];

  //         // Check if there are more pages to fetch
  //         hasMore = response.nextPageToken || response.pagination?.hasMore || false;
  //         cursor = response.nextPageToken || response.pagination?.nextCursor || null;

  //         // Safety check to prevent infinite loops
  //         if (!cursor || allCorrespondence.length >= 2500) {
  //           hasMore = false;
  //         }
  //       } else {
  //         hasMore = false;
  //       }
  //     }

  //     // Return data in the same format as the original API
  //     const result = {
  //       data: allCorrespondence,
  //       pageSize: allCorrespondence.length,
  //       totalMatches: allCorrespondence.length
  //     };

  //     console.log('Response from API:', result);
  //     return result;

  //   } catch (error) {
  //     console.error('Error fetching sales correspondence:', error);
  //     throw error;
  //   }
  // }

  // getMatchesPaginated(options: any = {}) {
  //   return this.http.post(
  //     'https://europe-west3-mona-ai-pwa-firebase.cloudfunctions.net/database',
  //     {
  //       endpoint: 'getMatchesFromDatabaseForPlatform',
  //       apiKey: 'asd',
  //       uid: this.authService.returnUserId(),
  //       platform: 'MONA',
  //       permission: 'readData',
  //       // Pagination and filter options
  //       pageSize: options.pageSize || 50,
  //       cursor: options.cursor || null,
  //       minScore: options.minScore || 50,
  //       dateFrom: options.dateFrom || null,
  //       dateTo: options.dateTo || null
  //     },
  //     {
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept-Encoding': 'gzip, deflate'
  //       }
  //     }
  //   );
  // }

  // Updated service methods to work with the new API pagination
  // All methods maintain the same interface while adapting to the new API internally

  // Base URL for API calls
  private readonly API_URL = 'https://europe-west3-mona-ai-pwa-firebase.cloudfunctions.net/database';
  private readonly MAX_TOTAL_RECORDS = 5000; // Set a reasonable upper limit for safety

  /**
   * Gets all matches from the API by automatically fetching all pages
   * @returns Promise with all matches consolidated into a single response
   */
  // async getMatchesFromAPI() {
  //   const MAX_PAGE_SIZE = 250;         // fixed by the API
  //   const allMatches: any[] = [];
  //   let hasMore = true;
  //   let nextPageToken: string | null = null;
  //   let totalCount = 0;
  //   let batchNumber = 1;

  //   console.log('Starting to fetch all matches in batches...');

  //   while (hasMore) {
  //     const offset = nextPageToken ?? '0';
  //     console.log(`Fetching batch #${batchNumber} (offset ${offset})…`);

  //     interface ApiResponse {
  //       total: number;
  //       count: number;
  //       emailsToBeSent: any[];
  //       pagination: {
  //         nextPageToken: string | null;
  //         total: number;
  //         hasMore: boolean;
  //       };
  //     }

  //     const response = await this.http
  //       .post<ApiResponse>(
  //         this.API_URL,
  //         {
  //           endpoint: 'getMatchesFromDatabaseForPlatform',
  //           apiKey: 'asd',
  //           uid: this.authService.returnUserId(),
  //           platform: 'MONA',
  //           paginationToken: nextPageToken
  //         },
  //         { headers: { 'Content-Type': 'application/json' } }
  //       )
  //       .toPromise();

  //       console.log(response);

  //     // On first page, stash the total
  //     if (batchNumber === 1) {
  //       totalCount = response.total;
  //       console.log(`Total records available: ${totalCount}`);
  //     }

  //     const matches = response.emailsToBeSent || [];
  //     if (matches.length) {
  //       allMatches.push(...matches);
  //       console.log(
  //         `Batch #${batchNumber} added ${matches.length} (fetched ${allMatches.length}/${totalCount})`
  //       );

  //       // prepare for next iteration
  //       nextPageToken = response.pagination.nextPageToken;
  //       hasMore =
  //         !!nextPageToken &&
  //         allMatches.length < totalCount &&
  //         allMatches.length < this.MAX_TOTAL_RECORDS;

  //       if (!hasMore) {
  //         console.log('No more pages or reached your max-record limit.');
  //       }
  //     } else {
  //       console.log('No matches returned in this batch.');
  //       hasMore = false;
  //     }

  //     batchNumber++;
  //   }

  //   return {
  //     total: totalCount,
  //     count: allMatches.length,
  //     emailsToBeSent: allMatches,
  //     pagination: {
  //       nextPageToken: null,
  //       total: totalCount,
  //       hasMore: false
  //     }
  //   };
  // }

  /**
   * Gets all applicants with created timestamp from the API
   * @returns Promise with all applicants
   */
  async getApplicantsWithCreatedFromAPI() {
    try {
      console.log('Fetching all applicants...');

      // Based on server code, this endpoint doesn't support pagination
      // It returns all applicants from the last 30 days in a single call
      const response: any = await this.http.post(
        this.API_URL,
        {
          endpoint: 'getApplicantsFromDatabaseForPlatform',
          apiKey: 'asd',
          uid: this.authService.returnUserId(),
          platform: 'MONA'
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      ).toPromise();

      let applicants = [];

      // Check if we got valid data
      if (response && response.data) {
        applicants = response.data;
        console.log(`Retrieved ${applicants.length} applicants from the last 30 days.`);
      } else {
        console.log('No applicants found or invalid response.');
      }

      // Return data in the same format as the original API
      const result = {
        data: applicants,
        count: applicants.length
      };

      return result;

    } catch (error) {
      console.error('Error fetching applicants:', error);
      // same shape as result, but empty
      return {
        data: [],
        count: 0
      };
    }
  }

  /**
   * Gets all sales correspondence from the API by automatically fetching all pages
   * @returns Promise with all correspondence consolidated into a single response
   */
  async getSalesCorrespondenceFromDatabaseFromAPI() {
    // Use server's maximum page size to minimize the number of requests
    const pageSize = 50;
    let allCorrespondence = [];
    let hasMore = true;
    let nextPageToken = null;
    let totalCount = 0;
    let firstResponse = null;

    try {
      console.log('Starting to fetch all sales correspondence in batches...');
      let batchNumber = 1;

      // Keep fetching pages until we have all the data
      while (hasMore) {
        console.log(`Fetching batch #${batchNumber}...`);

        const response: any = await this.http.post(
          this.API_URL,
          {
            endpoint: 'getSalesCorrespondenceFromDatabase',
            apiKey: 'asd',
            uid: this.authService.returnUserId(),
            platform: 'MONA',
            paginationToken: nextPageToken
          },
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        ).toPromise();

        // Keep the first response to use its structure and totalCount
        if (!firstResponse) {
          firstResponse = response;
          totalCount = response?.pagination?.total || 0;
          console.log(`Total records available: ${totalCount}`);
        }

        // Check if we got valid data
        if (response?.data && response.data.length > 0) {
          // Add this page of data to our collection
          allCorrespondence = [...allCorrespondence, ...response.data];
          console.log(`Batch #${batchNumber} added ${response.data.length} records. Total fetched: ${allCorrespondence.length}`);

          // Check if there are more pages to fetch
          nextPageToken = response.pagination?.nextPageToken || null;
          hasMore = !!nextPageToken;

          // Safety checks to prevent infinite loops or excessive data
          if (!hasMore) {
            console.log('No more pages available.');
          }
          if (allCorrespondence.length >= this.MAX_TOTAL_RECORDS) {
            console.log(`Maximum record limit (${this.MAX_TOTAL_RECORDS}) reached.`);
            hasMore = false;
          }
          if (allCorrespondence.length >= totalCount) {
            console.log('All available records retrieved.');
            hasMore = false;
          }
        } else {
          console.log('No correspondence in this batch or invalid response.');
          hasMore = false;
        }

        batchNumber++;
      }

      // Create a consolidated response that looks like a single page response
      // but contains all data from all pages
      const result = {
        data: allCorrespondence,
        pageSize: allCorrespondence.length,
        totalMatches: totalCount || allCorrespondence.length,
        // Include pagination info for consistency, but mark as complete
        pagination: {
          nextPageToken: null,
          total: totalCount || allCorrespondence.length,
          hasMore: false
        }
      };

      console.log(`Completed fetching all sales correspondence. Total records: ${allCorrespondence.length}`);
      return result;

    } catch (error) {
      console.error('Error fetching sales correspondence:', error);
      // return empty but correctly shaped
      return {
        data: [],
        pageSize: 0,
        totalMatches: 0,
        pagination: {
          nextPageToken: null,
          total: 0,
          hasMore: false
        }
      };
    }
  }

  /**
   * Gets paginated matches - but automatically fetches all pages if no pagination options provided
   * This method maintains the same interface as before but adapts to the new API internally
   * @param options Pagination and filter options
   * @returns Observable with matches (either paginated or all, depending on options)
   */
  getMatchesPaginated(options: any = {}) {
    // If specific pagination is requested, use it
    if (options.paginationToken || options.cursor || options.pageSize || options.page) {
      console.log('Using paginated matches retrieval with provided pagination options');
      return this.http.post(
        this.API_URL,
        {
          endpoint: 'getMatchesFromDatabaseForPlatform',
          apiKey: 'asd',
          uid: this.authService.returnUserId(),
          platform: 'MONA',
          // Pagination and filter options - updated to match new API
          paginationToken: options.paginationToken || options.cursor || null,
          minScore: options.minScore || 50
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
    } else {
      // If no pagination specified, call our method that fetches everything
      // but wrap it in an Observable to maintain the same interface
      console.log('No pagination options provided, fetching all matches');
      return new Observable(observer => {
        this.getMatchesFromAPI()
          .then(result => {
            observer.next(result);
            observer.complete();
          })
          .catch(error => {
            observer.error(error);
          });
      });
    }
  }

  /**
   * Gets matches by timeframe - either paginated or all matches in the timeframe
   * @param options Timeframe and pagination options
   * @returns Observable with matches in specified timeframe
   */
  getMatchesByTimeframe(options: any = {}) {
    // If specific pagination is requested, use it
    if (options.paginationToken || options.cursor || options.pageSize || options.page) {
      console.log('Using paginated timeframe matches retrieval with provided pagination options');
      return this.http.post(
        this.API_URL,
        {
          endpoint: 'getMatchesByTimeframe',
          apiKey: 'asd',
          uid: this.authService.returnUserId(),
          platform: 'MONA',
          // Date range parameters
          startDate: options.startDate || options.dateFrom || null,
          endDate: options.endDate || options.dateTo || null,
          // Pagination
          paginationToken: options.paginationToken || options.cursor || null,
          // Additional options
          minScore: options.minScore || 50
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
    } else {
      // For timeframe queries without pagination, we need to fetch all pages
      // and combine them into one response
      console.log('Fetching all matches within the specified timeframe');

      return new Observable(observer => {
        this.fetchAllTimeframeMatches(options)
          .then(result => {
            observer.next(result);
            observer.complete();
          })
          .catch(error => {
            observer.error(error);
          });
      });
    }
  }

  /**
   * Helper function that fetches all pages for a timeframe query
   * @param options Timeframe options
   * @returns Promise with all matches in the timeframe
   */
  private async fetchAllTimeframeMatches(options: any = {}) {
    let allMatches = [];
    let hasMore = true;
    let nextPageToken = null;
    let totalCount = 0;
    let firstResponse = null;

    try {
      console.log('Starting to fetch all timeframe matches in batches...');
      let batchNumber = 1;

      while (hasMore) {
        console.log(`Fetching timeframe batch #${batchNumber}...`);

        const response: any = await this.http.post(
          this.API_URL,
          {
            endpoint: 'getMatchesByTimeframe',
            apiKey: 'asd',
            uid: this.authService.returnUserId(),
            platform: 'MONA',
            startDate: options.startDate || options.dateFrom || null,
            endDate: options.endDate || options.dateTo || null,
            minScore: options.minScore || 50,
            paginationToken: nextPageToken
          },
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        ).toPromise();

        // Keep the first response to use its structure
        if (!firstResponse) {
          firstResponse = response;
          totalCount = response?.pagination?.total || 0;
          console.log(`Total timeframe records available: ${totalCount}`);
        }

        // Process the response data
        if (response?.data?.emailsToBeSent && response.data.emailsToBeSent.length > 0) {
          allMatches = [...allMatches, ...response.data.emailsToBeSent];
          console.log(`Timeframe batch #${batchNumber} added ${response.data.emailsToBeSent.length} records. Total fetched: ${allMatches.length}`);

          // Check if there are more pages to fetch
          nextPageToken = response.pagination?.nextPageToken || null;
          hasMore = !!nextPageToken;

          // Safety checks
          if (!hasMore) {
            console.log('No more timeframe pages available.');
          }
          if (allMatches.length >= this.MAX_TOTAL_RECORDS) {
            console.log(`Maximum record limit (${this.MAX_TOTAL_RECORDS}) reached.`);
            hasMore = false;
          }
          if (allMatches.length >= totalCount) {
            console.log('All available timeframe records retrieved.');
            hasMore = false;
          }
        } else {
          console.log('No timeframe matches in this batch or invalid response.');
          hasMore = false;
        }

        batchNumber++;
      }

      // Create a consolidated response with all timeframe matches
      const result = {
        total: totalCount || allMatches.length,
        count: allMatches.length,
        data: { emailsToBeSent: allMatches },
        pagination: {
          nextPageToken: null,
          total: totalCount || allMatches.length,
          hasMore: false
        },
        timeframe: {
          startDate: options.startDate || options.dateFrom || null,
          endDate: options.endDate || options.dateTo || null,
          minScore: options.minScore || 50
        }
      };

      console.log(`Completed fetching all timeframe matches. Total records: ${allMatches.length}`);
      return result;

    } catch (error) {
      console.error('Error fetching timeframe matches:', error);
      throw error;
    }
  }

  /**
   * Gets match insights within a timeframe
   * @param options Timeframe options
   * @returns Observable with match insights
   */
  getMatchesInsights(options: any = {}) {
    return this.http.post(
      this.API_URL,
      {
        endpoint: 'getMatchesInsights',
        apiKey: 'asd',
        uid: this.authService.returnUserId(),
        platform: 'MONA',
        startDate: options.startDate || options.dateFrom || null,
        endDate: options.endDate || options.dateTo || null
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
  }

  getAllNewAndOldApplicants() {
    let applicants = [];
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .get()
      .then((snap) => {
        snap.forEach((doc: any) => {
          let applicant = doc.data();
          applicant.id = doc.id;
          applicants.push(applicant);
        });
        return applicants;
      });
  }

  getAllActiveInterviews() {
    return this.app2.firestore.collection(FirebaseConstants.jobOffers).where("status", "==", "public").get();
  }

  getAllApplicants() {
    let date = new Date("2025-01-01");
    return this.app2.firestore.collection(FirebaseConstants.applicants).where("created", ">=", date).get();
  }

  async getContingentApplicants(timestamp) {
    let applicants = [];
    let activeApplicants = await this.fetchContingentApplicants(
      this.getApplicants(),
      timestamp,
    );
    let deletedApplicants = await this.fetchContingentApplicants(
      this.getDeletedApplicants(),
      timestamp,
    );
    return applicants.concat(activeApplicants, deletedApplicants);
  }

  async fetchContingentApplicants(collection, timestamp) {
    let applicants = [];
    // let date = new Date(timestamp.seconds * 1000)
    // await collection.where('created', '>=', date).get().then((snap) => {
    //   snap.forEach((doc: any) => {
    //     let applicant = doc.data();
    //     applicant.id = doc.id;
    //     applicants.push(applicant);
    //   });
    // });
    return applicants;
  }

  getDeletedApplicants() {
    return this.app2.firestore.collection(FirebaseConstants.deletedApplicants);
  }

  getApplicantProfiles(): firebase.firestore.CollectionReference {
    return this.app2.firestore.collection(FirebaseConstants.applicantProfile);
  }

  getApplicantProfileDetail(id): firebase.firestore.DocumentReference {
    return this.app2.firestore.collection('applicantProfile').doc(id);
  }

  getPicklistApplicantContracts(): firebase.firestore.CollectionReference {
    return this.app2.firestore.collection('kunden');
  }

  createWorkflow(form) {
    return this.app2.firestore.collection(FirebaseConstants.workflows).add({
      name: form.name,
      appliesto: form.appliesto,
      whenthishappens: form.whenthishappens,
      dothis: form.dothis,
      id: form.id,
      receiver: form.receiver,
      calendlyLink: form.calendlyLink || '',
      when: form.when,
      receivers: form.receivers || [],
      created: new Date(),
      createdISO: new Date().toISOString(),
      createdGerman: new Date().toLocaleString('de-DE'),
      // new ones
      workflowSendEmailSubject: form.workflowSendEmailSubject,
      emails: form.emails || [],
      emailText: form.emailText || '',
      smsCountryCode: form.smsCountryCode || '',
      smsPhoneNumbers: form.smsPhoneNumbers || [],
      //added phoneNumber and WhatsappNumber (smsPhoneNumbers when undefined should also be [], maybe change in the future) (31.10.2024)
      callPhoneNumbers: form.callPhoneNumbers || [],
      whatsAppPhoneNumbers: form.whatsAppPhoneNumbers || [],
      smsText: form.smsText || '',
      information: form.information || [],
      dynamicAttachment: form.dynamicAttachment || '',
      workflowSendEmailMessage: form.workflowSendEmailMessage || '',
      customTime: form.customTime || {},
      attachment: form.attachment || '',
      attachmentURL: form.attachmentURL || '',
      document: form.document || '',
      documentURL: form.documentURL || '',
      documentName: form.documentName || '',
      agent: form.agent || '',
      prompt: form.prompt || '',
      status: 'aktiv',
      // superior changes
      lastChosenWorkflow: form.lastChosenWorkflow || '',
      //priority of workflow should be priorityOfWorkflow. If old workflow have some broken things, maybe revert, but think of another way to save this. (31.10.2024)
      // priorityOfWorkflow: form.lastChosenWorkflowDate || "",
      priorityOfWorkflow: form.priorityOfWorkflow || '',
      subWorkflows: form.subWorkflows || [],
      lastChosenWorkflowMatching: form.lastChosenWorkflowMatching || {},
      reminder: form.reminder || {},
    });
  }

  createCommunicationWorkflow(form) {
    // Pre-generate a document ID
    const docRef = this.app2.firestore.collection(FirebaseConstants.workflows).doc();
    const newId = docRef.id;


    const workflowData = {
      id: newId,
      isCommunication: form.isCommunication,
      name: form.name,
      url: form.url
    };

    return docRef.set(workflowData)
      .then(() => {
        console.log("Document successfully written with ID: ", newId);
        return docRef;
      });
  }

  isLeffer(): boolean {
    //CustomerNumber 1011 is Leffer
    //Checking the customerNumber because at the moment just Leffer has RecruitmentTests (11 May 2023)
    if (this.customerNumber === 1011) {
      return true;
    }
    return false;
  }

  updateCommunicationWorkflow(form) {
    return this.app2.firestore.collection(FirebaseConstants.workflows).doc(form.id).update({
      name: form.name,
      url: form.url
    });
  }

  createDeletedJobOffer(id, data) {
    return this.app2.firestore
      .collection(FirebaseConstants.deletedJobOffers)
      .doc(id)
      .set(data);
  }

  createJobOffer(form) {
    var date = this.getActualDate();
    console.log(form);
    return this.app2.firestore
      .collection(FirebaseConstants.jobOffers)
      .add({
        jobTitle: form.jobTitle || '',
        introduction: form.introduction || '',
        tasks: form.tasks || '',
        qualifications: form.qualifications || '',
        benefits: form.benefits || '',
        closingwords: form.closingwords || '',
        money: form.money || '',
        education: form.education || '',
        experience: form.experience || '',
        employment: form.employment || '',
        careerLevel: form.careerLevel || '',
        jobCategory: form.jobCategory || '',
        applicationForm: form.applicationForm || '',
        employmentType: form.employmentType || '',
        applicationTime: form.applicationTime || '',
        country: form.country || '',
        public: form.public,
        city: form.city || '',
        assessmentTestTitle: form.assessmentTestTitle || '',
        uploadLogo: form.uploadLogo || '',
        selectedFont: form.selectedFont || 'Manrope',
        selectedHeaderColor: form.selectedHeaderColor || '',
        selectedBodyColor: form.selectedBodyColor || '',
        selectedCompanyTitle: form.selectedCompanyTitle || '#ffffff',
        creationDate: date || '',
        documents: form.documents || [],
        isFromFirebase: true,
        avatar: form.avatar || {},
        languages: form.languages || [],
        messages: form.messages || [],
        conditionalWorkflow: form.conditionalWorkflow || {},
        flowcharts: form.flowcharts || [],
        isAutomaticApplication: form.isAutomaticApplication || false,
        isAutomaticContract: form.isAutomaticContract || false,
        isAutomaticVoice: form.isAutomaticVoice || false,
        isAutomaticCV: form.isAutomaticCV || false,
        isFeedback: form.isFeedback || true,
        codingChallenge: form.codingChallenge || {},
        status: form.status || '',
        created: new Date(),
        updated: new Date(),
        qnaPairs: form.qnaPairs || [],
        testmode: form.testmode || false,
        dfcxAgent: form.dfcxAgent || '',
        isFastApplication: form.isFastApplication,
        isDetailedApplication: form.isDetailedApplication,
        isAutomaticRecruitmentTest: form.isAutomaticRecruitmentTest || false,
        isQandAAllowed: form.isQandAAllowed || false,
        isForcedLanguage: form.isForcedLanguage || false,
        defaultJobOfferLanguage: form.defaultJobOfferLanguage || '',
      })
      .then(function (docRef) {
        console.log(docRef.id);
        return docRef.id;
      });
  }

  createZvooveJob(job) {
    let domParser = new DOMParser();
    return this.app2.firestore.collection(FirebaseConstants.jobOffers).add({
      applicationForm: 'Deutsch',
      applicationTime: '',
      avatar: {
        avatarId: 'anna_costume1_cameraA',
        avatarName: 'MONA',
        name: 'Anna',
        toggle: true,
      },
      benefits:
        domParser.parseFromString(job.Perspektiven, 'text/html').body
          .textContent || '',
      careerLevel: '',
      city: job.EinsatzortOrt || '',
      closingWords: '',
      codingChallenge: [],
      conditionalWorkflow: job.conditionalWorkflow,
      country: '',
      created: new Date(),
      dfcxAgent: '',
      documents: {},
      education: '',
      employment: '',
      employmentType: '',
      experience: '',
      introduction:
        domParser.parseFromString(job.Arbeitgebervorstellung, 'text/html').body
          .textContent || '',
      isAutomaticApplication: true,
      isAutonaticCV: false,
      isAutomaticContract: false,
      isAutomaticRecruitmentTest: false,
      isAutomaticVoice: false,
      isDetailedApplication: false,
      isFastApplication: false,
      isQandAAllowed: false,
      isForcedLanguage: false,
      jobCategory: '',
      jobTitle:
        domParser.parseFromString(job.BezeichnungAusschreibung, 'text/html')
          .body.textContent || '',
      languages: [{ language: 'deutsch', toggle: true }],
      messages: job.messages,
      money: '',
      public: true,
      qnaPairs: [],
      qualifications:
        domParser.parseFromString(job.FachlicheAnforderungen, 'text/html').body
          .textContent || '',
      status: 'aktiv',
      tasks:
        domParser.parseFromString(job.Aufgaben, 'text/html').body.textContent ||
        '',
      updated: new Date(),
    });
  }

  archiveJobOffer(id) {
    return this.app2.firestore
      .collection(FirebaseConstants.jobOffers)
      .doc(id)
      .update({
        status: 'archiviert',
      });
  }
  templateJobOffer(id) {
    return this.app2.firestore
      .collection(FirebaseConstants.jobOffers)
      .doc(id)
      .update({
        status: 'template',
      });
  }

  updateExternalIdForJobOffer(externalId, id) {
    return this.app2.firestore
      .collection(FirebaseConstants.jobOffers)
      .doc(id)
      .update({
        externalId: externalId,
      });
  }

  updatejobOfferInformationAI(id, form) {
    return this.app2.firestore
      .collection('indexstellenanzeigen')
      .doc(id)
      .update({
        AIFeedback: form,
        status: 'AI',
      });
  }

  updateJobOfferApplicantsToZero(id: string) {
    this.app2.firestore.collection(FirebaseConstants.jobOffers).doc(id).update({
      applicants: [],
    });
  }

  async ReactivateJobOffer(id, form) {
    const res = (await this.getDeletedJobOffersDetail(id).get()).data();
    console.log(res);
    await this.app2.firestore
      .collection(FirebaseConstants.jobOffers)
      .doc(id)
      .set(res);
    this.updateJobOffer(id, form);
    await this.app2.firestore
      .collection(FirebaseConstants.deletedJobOffers)
      .doc(id)
      .delete();
  }
  async updateJobOffer(id, form) {
    var date = this.getActualDate();
    await this.app2.firestore
      .collection(FirebaseConstants.jobOffers)
      .doc(id)
      .update({
        jobTitle: form.jobTitle || '',
        introduction: form.introduction || '',
        tasks: form.tasks || '',
        qualifications: form.qualifications || '',
        benefits: form.benefits || '',
        closingwords: form.closingwords || '',
        money: form.money || '',
        education: form.education || '',
        experience: form.experience || '',
        employment: form.employment || '',
        careerLevel: form.careerLevel || '',
        jobCategory: form.jobCategory || '',
        applicationForm: form.applicationForm || '',
        employmentType: form.employmentType || '',
        applicationTime: form.applicationTime || '',
        country: form.country || '',
        public: form.public || '',
        testmode: form.testmode || false,
        city: form.city || '',
        assessmentTestTitle: form.assessmentTestTitle || '',
        uploadLogo: form.uploadLogo || '',
        selectedFont: form.selectedFont || 'Manrope',
        selectedHeaderColor: form.selectedHeaderColor || '',
        selectedBodyColor: form.selectedBodyColor || '',
        selectedCompanyTitle: form.selectedCompanyTitle || '#ffffff',
        creationDate: date || '',
        documents: form.documents || [],
        languages: form.languages || [],
        avatar: form.avatar || {},
        messages: form.messages || [],
        conditionalWorkflow: form.conditionalWorkflow || {},
        flowcharts: form.flowcharts || [],
        status: form.status,
        qnaPairs: form.qnaPairs || [],
        dfcxAgent: form.dfcxAgent || '',
        isAutomaticApplication: form.isAutomaticApplication || false,
        isAutomaticContract: form.isAutomaticContract || false,
        isAutomaticVoice: form.isAutomaticVoice || false,
        isAutomaticCV: form.isAutomaticCV || false,
        isAutomaticRecruitmentTest: form.isAutomaticRecruitmentTest || false,
        isQandAAllowed: form.isQandAAllowed || false,
        isForcedLanguage: form.isForcedLanguage || false,
        isFeedback: form.isFeedback || false,
        codingChallenge: form.codingChallenge || {},
        updated: new Date(),
        defaultJobOfferLanguage: form.defaultJobOfferLanguage || '',
      });
  }

  // async setAutoSaveFlowchart(id, form) {
  //   return this.app2.firestore.collection(FirebaseConstants.jobOffers).doc(id).set({
  //     autoSaveConditionalWorkflow: form.conditionalWorkflow || {},
  //     autoSaveFlowcharts: form.flowcharts || [],
  //   });
  // }

  async updateAutoSaveFlowchart(id, form) {
    console.log("updateAutoSaveFlowchart", form.conditionalWorkflow, form.flowcharts);
    return this.app2.firestore.collection(FirebaseConstants.jobOffers).doc(id).update({
      autoSaveConditionalWorkflow: form.conditionalWorkflow || {},
      autoSaveFlowcharts: form.flowcharts || []
    });
  }

  async updateAutoSaveMessages(id, form, isAutomaticCV, messageNodes) {
    console.log(form, messageNodes);
    let autoSaveMessages = form.messages || [];

    if (isAutomaticCV) {
      autoSaveMessages = autoSaveMessages.filter((message) => {
        return message.value !== 'Danke' && message.value !== 'Sprache' && message.value !== 'Ende' && message.value !== 'Vertrag' && message.value !== 'Q&A';
      });
    }
    else {
      autoSaveMessages = autoSaveMessages.filter((message) => {
        return message.value !== 'Danke' && message.value !== 'Sprache' && message.value !== 'Ende' && message.value !== 'Vertrag' && message.value !== 'Q&A' && message.value !== 'CV Upload';
      });
    }

    const refMessages = [];
    autoSaveMessages.forEach((message) => {
      refMessages.push(message);
    });
    autoSaveMessages = []
    refMessages.forEach((messageNode) => {

      if (messageNode.label != "End Session" && messageNode.label != "Start") {
        const message = refMessages.filter(msg => msg.parameterMap['deutsch'] == messageNode.parameterMap['deutsch'] || msg.languageMap['deutsch'] == messageNode.languageMap['deutsch']);
        if (message) {
          //do the loop slower to get easily readable messages (similar to messages[]). If this is slow, please change it
          const messageWithCorrectLang = message.find(msg => msg.language === messageNode.language)
          autoSaveMessages.push(messageWithCorrectLang);
        }
        else {
          console.log("!!!!!!!!!!!!!!!!can not find message", messageNode);
          const message2 = messageNodes.find(msg => msg.parameterMap['deutsch'] == messageNode.parameterMap['deutsch'] || msg.languageMap['deutsch'] == messageNode.languageMap['deutsch']);
          if (message2) {
            autoSaveMessages.push(message2);
          }
          else {
            console.log("!!!!!!!!!!!!!!!!can not find message", messageNode);
          }
        }
      }
    });

    console.log("autoSaveMessages", autoSaveMessages);

    let transferMessageNodes = [];
    messageNodes.forEach((messageNode) => {
      if (messageNode.rightMessage.value) {

      }
      else {
        messageNode.rightMessage.value = "";
      }

      if (messageNode.standAlone) {

      }
      else {
        messageNode.standAlone = false;
      }

      transferMessageNodes.push({

        data: messageNode.data,
        dimension: messageNode.dimension,
        filtered: messageNode.filtered,
        id: messageNode.id,
        inPoint: messageNode.inPoint,
        label: messageNode.label,
        languageMap: messageNode.languageMap,
        meta: messageNode.meta,
        outPoint: messageNode.outPoint,
        parameterMap: messageNode.parameterMap,
        position: messageNode.position,
        rightMessage: messageNode.rightMessage,
        shape: messageNode.shape,
        standAlone: messageNode.standAlone,
        status: messageNode.status,
        text: messageNode.text,
        transform: messageNode.transform,
        visible: messageNode.visible
      });


    });



    console.log("autoSaveMessageNodes", transferMessageNodes);

    return this.app2.firestore.collection(FirebaseConstants.jobOffers).doc(id).update({
      autoSaveMessages: autoSaveMessages || [],
      autoSaveMessageNodes: transferMessageNodes || [],
    });
  }

  async getAutoSaveFlowchart(id) {
    return this.app2.firestore.collection(FirebaseConstants.jobOffers).doc(id).get();
  }

  private getActualDate() {
    var date = new Date();
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0');
    var yyyy = date.getFullYear();
    var today = dd + '.' + mm + '.' + yyyy;
    return today;
  }

  getContracts(): firebase.firestore.CollectionReference {
    return this.app2.firestore.collection(FirebaseConstants.contracts);
  }

  getContract(id): firebase.firestore.DocumentReference {
    return this.app2.firestore.collection(FirebaseConstants.contracts).doc(id);
  }

  getContractyName(name) {
    return this.app2.firestore
      .collection(FirebaseConstants.contracts)
      .where('name', '==', name);
  }

  getContractSrc(name) {
    var storageRef = this.storage.ref(name);
    return storageRef.getDownloadURL().toPromise();
  }

  getNewContractId() {
    return this.newContractId;
  }

  async deleteContract(id) {
    this.getContract(id)
      .get()
      .then((snap) => {
        var filepath = snap.data().downloadURL;
        this.storage.storage.refFromURL(filepath).delete();
      })
      .then(() => {
        this.getContract(id)
          .delete()
          .then(() => {
            console.log('deleted');
          });
      });
  }

  async downloadContract(filename, id) {
    await this.getContract(id)
      .get()
      .then((snap) => {
        var filepath = snap.data().downloadURL;
        this.http.get(filepath, { responseType: 'blob' }).subscribe((res) => {
          var a = document.createElement('a');
          var url = window.URL.createObjectURL(res);
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
        });
      });
  }

  deleteApplicantFile(downloadURL, applicantId) {
    this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(applicantId)
      .get()
      .then((snap) => {
        var data = snap.data();
        var files = data.files;
        var newFiles = [];
        files.forEach((file) => {
          if (file.downloadURL != downloadURL) {
            newFiles.push(file);
          }
        });
        this.storage.storage.refFromURL(downloadURL).delete();
        this.app2.firestore
          .collection(FirebaseConstants.applicants)
          .doc(applicantId)
          .update({ files: newFiles });
      });
  }

  storeFilesFirebase(
    image,
    collection: string,
    documentId?: string,
    type?: string,
  ) {
    if (documentId) {
      var files = this.getApplicantFiles(documentId);
      files.then((snap) => {
        var f = [];
        if (snap) {
          if (type) {
            snap.push({
              createdISO: image.createdISO,
              name: image.name,
              downloadURL: image.downloadURL,
              type: type,
            });
          } else {
            snap.push({
              createdISO: image.createdISO,
              name: image.name,
              downloadURL: image.downloadURL,
            });
          }
          // f.push({
          //   createdISO: image.createdISO,
          //   name: image.name,
          //   downloadURL: image.downloadURL
          // })
          this.app2.firestore.collection(collection).doc(documentId).update({
            files: snap,
          });
        } else {
          if (type) {
            f.push({
              createdISO: image.createdISO,
              name: image.name,
              downloadURL: image.downloadURL,
              type: type,
            });
          } else {
            f.push({
              createdISO: image.createdISO,
              name: image.name,
              downloadURL: image.downloadURL,
            });
          }
          this.app2.collection(collection).doc(documentId).update({
            files: f,
          });
        }
      });
    } else {
      this.app2.firestore
        .collection(collection)
        .add(image)
        .then((res) => {
          this.newContractId = res.id;
        })
        .catch((err) => {
          console.log('error', err);
        });
    }
  }

  storeAICVFeedback(feedback) {
    this.app2.collection(FirebaseConstants.aiCVFeedback).add({
      feedback: feedback,
      created: new Date(),
    });
  }

  storeAICVFeedbackForMatching(id, feedback) {
    this.app2
      .collection(FirebaseConstants.applicants)
      .doc(id)
      .update({
        feedbackForMatching: feedback,
        created: new Date(),
        isFeedbackForMatching: true,
        createdISODate: new Date().toISOString(),
        createdISO: new Date().toISOString().slice(0, 10),
      });
  }

  getImageRef(fileStoragePath) {
    return this.storage.ref(fileStoragePath);
  }

  getCustomerImageRef(fileStoragePath) {
    return this.customerStorage.ref(fileStoragePath);
  }

  getCustomerDBImageRef(fileStoragePath) {
    console.log('this.storage', this.storage);
    return this.customerStorage.ref(fileStoragePath);
  }

  getCustomerUploadTask(fileStoragePath, file) {
    return this.customerStorage.upload(fileStoragePath, file);
  }

  getUploadTask(fileStoragePath, file) {
    return this.storage.upload(fileStoragePath, file);
  }

  saveAIDisclaimer(userId, disclaimer) {
    const disclaimerString = JSON.stringify(disclaimer);
    this.coolStore.firestore
      .collection('customers')
      .doc(userId)
      .collection('disclaimers')
      .add({
        created: new Date(),
        createdISO: new Date().toISOString(),
        createdGerman: new Date().toLocaleDateString('de-DE'),
        disclaimerSeen: true,
        disclaimerString: disclaimerString,
      });
  }

  confirmedAIDisclaimer(userId) {
    this.coolStore.firestore.collection('customers').doc(userId).update({
      disclaimerConfirmed: true,
      disclaimerConfirmedDate: new Date(),
    });
  }

  returnSeenDisclaimerStatus() {
    return this.seenDisclaimer;
  }

  returnConfirmedDisclaimerStatus() {
    return this.confirmedDisclaimer;
  }

  returnUserId() {
    return this.userId;
  }

  setUserStorage(uid) {
    this.coolStore.firestore
      .collection('customers')
      .doc(uid)
      .get()
      .then((snap) => {
        var customerData = snap.data();
        this.seenDisclaimer = customerData.disclaimerSeen || false;
        this.confirmedDisclaimer = customerData.disclaimerConfirmed || false;
        this.userId = uid;
        var user = customerData.kundennummer;
        this.coolStore.firestore
          .collection(FirebaseConstants.companies)
          .where(FirebaseConstants.kundennummer, '==', user)
          .get()
          .then((snap) => {
            if (snap.docs.length > 0) {
              var data = snap.docs[0].data();
              var platformId = PLATFORM_ID;
              this.customerStorage = new AngularFireStorage(
                data.database,
                'customerStorage',
                data.database.storageBucket,
                platformId,
                this.zone,
              );
            }
          });
      });
  }

  getAllVideos() {
    // part for new video generation
    // return this.videoStore.firestore.collection(FirebaseConstants.videos);
    return this.app2.firestore.collection(FirebaseConstants.videos);
  }

  getTeammembers(): firebase.firestore.CollectionReference {
    return this.app2.firestore.collection(FirebaseConstants.teammembers);
  }

  AddBlacklistCustomer(item) {
    this.app2.firestore.collection(FirebaseConstants.blacklist).add({
      email: item,
    });
  }

  async RemoveBlacklistCustomer(item) {
    let ids = [];
    await this.app2.firestore.collection(FirebaseConstants.blacklist).where("email", "==", item).get().then((snap) => {
      snap.forEach(async (doc) => {
        ids.push(doc.id);
        await this.app2.collection(FirebaseConstants.blacklist).doc(doc.id).delete();
      });
    });
    return ids;
  }

  GetBlacklist(): firebase.firestore.CollectionReference {
    return this.app2.firestore.collection(FirebaseConstants.blacklist);
  }

  async loadBlacklist(event?: any) {
    if (this.loading) return;
    this.loading = true;
    let batchSize = 25;
    if (event.name === "firstLoad") {
      this.lastDoc = null;
      this.blackListItems = [];
      this.hasMoreDataBlacklist = true;
    } else {
      this.hasMoreDataBlacklist = true;
    }

    let query = this.app2.firestore.collection(FirebaseConstants.blacklist)
      .orderBy('__name__')
      .limit(batchSize);
    if (this.lastDoc) {
      const lastId = this.lastDoc.id;
      console.log('Fetching batch after:', this.lastDoc?.id);
      query = query.startAfter(this.lastDoc);
    }

    try {
      const snapshot = await query.get();
      console.log('Snapshot:', snapshot);
      if (snapshot.empty) {
        console.log('No matching documents found.');
        this.hasMoreDataBlacklist = false;
        if (event) {
          event.target.complete();
          event.target.disabled = true;
        }
        this.loading = false;
        return [];
      } else {
        if (snapshot.docs) {
          console.log('Documents found:', snapshot.docs.length);
          const newItems = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          this.blackListItems.push(...newItems);
          if (snapshot.docs.length > 0) {
            this.lastDoc = snapshot.docs[snapshot.docs.length - 1];
          }

          if (snapshot.size < batchSize) {
            this.hasMoreDataBlacklist = false;
            console.log('All data loaded. Hiding + sign');
            if (event) {
              event.target.disabled = true;
            }
          }
          if (event) {
            event.target.complete();
          }

          console.log('Loading batch...');
          console.log('Batch size:', snapshot.docs.length);
          console.log('Last doc:', this.lastDoc?.id);
          return newItems;
        }
      }
    } catch (error) {
      console.error('Error loading emails:', error);
      if (event) event.target.complete(); // Fail-safe
      this.loading = false;
      return [];
    }
  }


  async updateTeammemberLocation(email, location) {
    return this.app2.firestore
      .collection(FirebaseConstants.teammembers)
      .where('email', '==', email)
      .get()
      .then((snap) => {
        snap.forEach((doc) => {
          this.app2.firestore
            .collection(FirebaseConstants.teammembers)
            .doc(doc.id)
            .update({
              locationName: location,
            });
        });
      });
  }

  retreiveTeammemberStatusByEmail(): firebase.firestore.CollectionReference {
    return this.app2.firestore.collection(FirebaseConstants.teammembers);
  }

  async updateTeammemberStatus(email, value) {
    return this.app2.firestore
      .collection(FirebaseConstants.teammembers)
      .where('email', '==', email)
      .get()
      .then((snap) => {
        console.log('snap', snap);
        snap.forEach((doc) => {
          this.app2.firestore
            .collection(FirebaseConstants.teammembers)
            .doc(doc.id)
            .update({
              status: value,
            })
            .then((snap) => {
              console.log(snap);
            })
            .catch((err) => {
              console.log(err);
            });
        });
      });
  }

  inviteTeammemberIntoSubCollection(email, accountId) {
    this.app2.collection(FirebaseConstants.teammembers).add({
      email: email,
      status: 'Mitarbeiter*in',
      accountId: accountId,
      created: new Date(),
      createdIso: new Date().toISOString().split('T')[0],
      createdIsoTime: new Date().toISOString(),
    });
    this.coolStore.firestore.collection(FirebaseConstants.customers).add({
      email: email,
      kundennummer: this.customerNumber,
      accountId: accountId,
      created: new Date(),
      createdIso: new Date().toISOString().split('T')[0],
      status: 'teammember',
      createdIsoTime: new Date().toISOString(),
    });
  }

  async inviteTeammember(email) {
    this.app2.collection(FirebaseConstants.teammembers).add({
      email: email,
      status: 'Mitarbeiter*in',
      created: new Date(),
      createdIso: new Date().toISOString().split('T')[0],
      createdIsoTime: new Date().toISOString(),
    });
    this.coolStore.firestore.collection(FirebaseConstants.customers).add({
      email: email,
      kundennummer: this.customerNumber,
      created: new Date(),
      createdIso: new Date().toISOString().split('T')[0],
      status: 'Mitarbeiter*in',
      createdIsoTime: new Date().toISOString(),
    });
  }

  async getTeammember(email) {
    return this.app2.firestore
      .collection(FirebaseConstants.teammembers)
      .where('email', '==', email)
      .get();
  }

  async getTeammemberCoolstore(id) {
    return this.coolStore.firestore
      .collection(FirebaseConstants.customers)
      .doc(id)
      .get();
  }

  updateTeammember(form) {
    this.app2.firestore
      .collection(FirebaseConstants.teammembers)
      .doc(form.value.teammemberId)
      .update({
        email: form.value.email,
        name: form.value.firstname + ' ' + form.value.lastname,
        status: 'Mitarbeiter*in',
      });
  }

  async updateCustomerTeamMember(kundennummer, uid, customerID) {
    let docRef = await this.coolStore.firestore
      .collection(FirebaseConstants.customers)
      .doc(uid);
    let doc = await docRef.get();
    if (doc.exists) {
      docRef.update({
        kundennummer: kundennummer,
      });
      this.coolStore.firestore
        .collection(FirebaseConstants.customers)
        .doc(customerID)
        .delete();
    } else {
      this.updateCustomerTeamMember(kundennummer, uid, customerID);
    }
  }

  getCompanyId() {
    var id = '';
    this.coolStore.firestore
      .collection('companies')
      .where(FirebaseConstants.kundennummer, '==', this.customerNumber)
      .get()
      .then((snap) => {
        snap.forEach((doc) => {
          return doc.id;
        });
      });
  }

  getCompany() {
    return this.coolStore.firestore
      .collection('companies')
      .where(FirebaseConstants.kundennummer, '==', this.customerNumber)
      .get();
  }

  getCompanyName(): Promise<string> {
    return this.getCompany().then((snap) => {
      const docs = snap.docs;
      if (docs.length > 0) {
        var doc = docs[0];
        var companyName = doc.data().name || doc.data().email;
        return Promise.resolve(companyName);
      }
    });
  }

  getDashboardSettings() {
    return this.app2.firestore
      .collection(FirebaseConstants.dashboardSettings)
      .get()
      .then((snap) => {
        if (snap == undefined) {
          this.app2.firestore
            .collection(FirebaseConstants.dashboardSettings)
            .add({});
        } else {
          let docs = snap.docs;
          if (docs != undefined && docs.length > 0) {
            return docs[0].data();
          }
        }
      });
  }

  updateDashboardSettings(timeDisponentSetting, moneyDisponentSetting) {
    this.app2.firestore
      .collection(FirebaseConstants.dashboardSettings)
      .get()
      .then((snap) => {
        if (snap.docs.length > 0) {
          snap.docs[0].ref.update({
            timeDisponentSetting: timeDisponentSetting,
            moneyDisponentSetting: moneyDisponentSetting,
          });
        } else {
          this.app2.firestore
            .collection(FirebaseConstants.dashboardSettings)
            .add({
              timeDisponentSetting: timeDisponentSetting,
              moneyDisponentSetting: moneyDisponentSetting,
            });
        }
      });
  }

  getCustomerPrice() {
    return this.coolStore.firestore
      .collection(FirebaseConstants.companies)
      .where(FirebaseConstants.kundennummer, '==', this.customerNumber)
      .get();
  }

  async getCustomer(email) {
    return this.coolStore.firestore
      .collection(FirebaseConstants.customers)
      .where('email', '==', email)
      .get();
  }

  signupTeammember(email, password) {
    this.auth = new AngularFireAuth(
      this.db,
      'CustomerDatabase',
      PLATFORM_ID,
      this.zone,
    );

    return this.auth
      .createUserWithEmailAndPassword(email, password)
      .then((newUserCredential: firebase.auth.UserCredential) => {
        firebase
          .firestore()
          .doc(`/customers/${newUserCredential.user.uid}`)
          .set({ email });
      })
      .catch((error) => {
        console.error(error);
        throw new Error(error);
      });
  }

  deleteTeammember(email) {
    this.coolStore.firestore
      .collection(FirebaseConstants.customers)
      .where('email', '==', email)
      .get()
      .then((snap) => {
        snap.forEach((doc) => {
          this.coolStore.firestore
            .collection(FirebaseConstants.customers)
            .doc(doc.id)
            .delete();
        });
      });
    this.app2.firestore
      .collection(FirebaseConstants.teammembers)
      .where('email', '==', email)
      .get()
      .then((snap) => {
        snap.forEach((doc) => {
          this.app2.firestore
            .collection(FirebaseConstants.teammembers)
            .doc(doc.id)
            .delete();
        });
      });

    var body = {
      email: email,
      customerNumber: this.customerNumber,
    };
    return this.http.post(cfRegionLinks.deleteUserMonaPlattform, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
  }

  deactivateAccount(email) {
    var body = {
      email: email,
      customerNumber: this.customerNumber,
    };
    return this.http.post(cfRegionLinks.deactivateUserMonaPlattform, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
  }

  addmatchingSettings(settings) {
    this.app2.firestore.collection(FirebaseConstants.matchingSettings).add({
      settings: settings,
      created: new Date(),
      createdIso: new Date().toISOString().split('T')[0],
      createdIsoTime: new Date().toISOString(),
    });
  }

  getMatchingSettings() {
    return this.app2.firestore.collection(FirebaseConstants.matchingSettings);
  }

  deleteWorkflow(id) {
    return this.app2.firestore.collection('workflows').doc(id).delete();
  }

  async getParticularWorkflow(id) {
    const docRef = this.app2.firestore.collection('workflows').doc(id);
    const docSnapshot = await docRef.get();
    if (docSnapshot.exists) {
      return docSnapshot.data();
    } else {
      return undefined;
    }
  }

  async ImportProfilAnlegen(profil) {
    return await this.app2.firestore.collection('applicants').add({
      anrede: profil.anrede || '',
      anschrift: profil.anschrift || '',
      berufswunsch: profil.berufswunsch || '',
      eingangsdatum: profil.eingangsdatum || '',
      email: profil.email || '',
      externeId: profil.externeId || '',
      facebook: profil.facebook || '',
      fuehrerschein: profil.fuehrerschein || '',
      fachkenntnisse: profil.fachkenntnisse || '',
      familienstand: profil.familienstand || '',
      feld1: profil.feld1 || '',
      feld2: profil.feld2 || '',
      feld3: profil.feld3 || '',
      feld4: profil.feld4 || '',
      feld5: profil.feld5 || '',
      geburtsdatum: profil.geburtsdatum || '',
      gehaltswunsch: profil.gehaltswunsch || '',
      hausnummer: profil.hausnummer || '',
      instagram: profil.instagram || '',
      interneId: profil.interneId || '',
      linkedin: profil.linkedin || '',
      mindestgehalt: profil.mindestgehalt || '',
      mobiltelefon: profil.mobiltelefon || '',
      nachname: profil.nachname || '',
      nationalitaet: profil.nationalitaet || '',
      notizen: profil.notizen || '',
      ort: profil.ort || '',
      pkw: profil.pkw || '',
      plz: profil.plz || '',
      quelle: profil.quelle || '',
      reisewunsch: profil.reisewunsch || '',
      socialmedia: profil.socialmedia || '',
      sprachen: profil.sprachen || '',
      status: profil.status || '',
      strasse: profil.strasse || '',
      telefon: profil.telefon || '',
      titel: profil.titel || '',
      umzugwunsch: profil.umzugwunsch || '',
      vorname: profil.vorname || '',
      xing: profil.xing || '',
      clicks: 0,
      seen: 0,
      profilStatus: 'aktiv',
      created: new Date(),
      IsoDate: new Date().toISOString().split('T')[0],
      lastChanged: new Date(),
      lastChangedIsoDate: new Date().toISOString().split('T')[0],
    });
  }

  profilAnlegen(profil) {
    return this.applicantProfile.add({
      anrede: profil.anrede,
      anschrift: profil.anschrift,
      applicationid: profil.applicationid,
      bereich: profil.bereich,
      beschreibung: profil.beschreibung,
      bewerberEinwilligung: profil.bewerberEinwilligung,
      bewertung: profil.bewertung,
      eingangsdatum: profil.eingangsdatum,
      einrichtung: profil.einrichtung,
      email: profil.email,
      endDatum: profil.endDatum,
      fuehrerschein: profil.fuehrerschein,
      geaendertdatum: profil.geaendertdatum,
      jobpost: profil.jobpost,
      kategorie: profil.kategorie,
      mobiltelefon: profil.mobiltelefon,
      nachname: profil.nachname,
      newsletter: profil.newsletter,
      notizen: profil.notizen,
      ort: profil.ort,
      pkw: profil.pkw,
      plz: profil.plz,
      positionen: profil.positionen,
      recruitmentStartdatum: profil.recruitmentStartdatum,
      schlagworte: profil.schlagworte,
      startDatum: profil.startDatum,
      status: profil.status,
      strasse: profil.strasse,
      talentpoolEinwilligung: profil.talentpoolEinwilligung,
      talentpoolEinwilligungDouble: profil.talentpoolEinwilligungDouble,
      telefon: profil.telefon,
      titel: profil.titel,
      unternehmen: profil.unternehmen,
      vorname: profil.vorname,
      clicks: 0,
      seen: 0,
      profilStatus: 'aktiv',
      created: new Date(),
      createdFirestore: firebase.firestore.FieldValue.serverTimestamp(),
      IsoDate: new Date().toISOString().split('T')[0],
      lastChanged: new Date(),
      lastChangedIsoDate: new Date().toISOString().split('T')[0],
    });
  }

  profilUpdate(profil) {
    return this.applicantProfile.doc(profil.id).update({
      anrede: profil.anrede,
      anschrift: profil.anschrift,
      applicationId: profil.applicationId,
      bereich: profil.bereich,
      beschreibung: profil.beschreibung,
      bewerberEinwilligung: profil.bewerberEinwilligung,
      bewertung: profil.bewertung,
      eingangsdatum: profil.eingangsdatum,
      einrichtung: profil.einrichtung,
      email: profil.email,
      endDatum: profil.endDatum,
      fuehrerschein: profil.fuehrerschein,
      geandertdatum: profil.geandertdatum,
      jobpost: profil.jobpost,
      kategorie: profil.kategorie,
      clicks: profil.clicks,
      seen: profil.seen,
      mobiltelefon: profil.mobiltelefon,
      nachname: profil.nachname,
      newsletter: profil.newsletter,
      notizen: profil.notizen,
      ort: profil.ort,
      pkw: profil.pkw,
      plz: profil.plz,
      positionen: profil.positionen,
      recruitmentStartdatum: profil.recruitmentStartdatum,
      schlagworte: profil.schlagworte,
      startDatum: profil.startDatum,
      status: profil.status,
      strasse: profil.strasse,
      talentpoolEinwilligung: profil.talentpoolEinwilligung,
      talentpoolEinwilligungDouble: profil.talentpoolEinwilligungDouble,
      telefon: profil.telefon,
      titel: profil.titel,
      profilStatus: 'aktiv',
      unternehmen: profil.unternehmen,
      vorname: profil.vorname,
      created: profil.created,
      createdFirestore: profil.createdFirestore,
      IsoDate: profil.IsoDate,
      lastChanged: new Date(),
      lastChangedIsoDate: new Date().toISOString().split('T')[0],
    });
  }

  profilDelete(id) {
    return this.applicantProfile.doc(id).delete();
  }

  profilArchive(id) {
    return this.applicantProfile.doc(id).update({
      profilStatus: 'archiviert',
      lastChanged: new Date(),
      lastChangedIsoDate: new Date().toISOString().split('T')[0],
    });
  }

  updateContractMessages(messages, docId) {
    const messagesJSON = JSON.stringify(Array.from(messages.entries()));
    this.getContract(docId).update(FirebaseConstants.messages, messagesJSON);
  }

  alertErrorUpload(kennziffer) {
    this.alertCtrl
      .create({
        header: 'Fehler beim Upload von ' + kennziffer,
        message: 'Bitte versuchen Sie es für die Person erneut.',
        buttons: ['OK'],
      })
      .then((alert) => alert.present());
  }

  createCompleetApplicant(obj) {
    this.app2.firestore.collection('compleetApplicants').add(obj);
  }

  getApplicantsAfterDate(date) {
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .where('created', '>=', date)
      .limit(1000);
  }

  getCompleetApplicant() {
    let startDate = new Date(2025, 1, 1);
    let endDate = new Date(2025, 1, 28);

    let applicants = [];
    this.app2.firestore
      .collection('compleetApplicants')
      .get()
      .then(async (snap) => {
        await snap.docs.forEach((doc) => {
          let data = doc.data();
          let created = data.created.toDate();
          if (created >= startDate && created <= endDate) {
            applicants.push(data);
          }
        });
      })
      .then(() => {
        console.log(applicants.length);
      });
  }

  getTalentionApplicants() {
    let startDate = new Date(2025, 3, 1);
    let endDate = new Date(2025, 3, 30);

    let applicants = [];
    // Use emailapplicants cause in talentionApplicants we would have to filter for the mandanten 
    this.app2.firestore
      .collection('emailapplicants')
      .get()
      .then(async (snap) => {
        await snap.docs.forEach((doc) => {
          let data = doc.data();
          let created = data.created
          if (created) {
            created = created.toDate();
            if (created >= startDate && created <= endDate) {
              applicants.push(data);
            }
          }
        });
      })
      .then(() => {
        console.log(applicants.length);
      });
  }

  async triggerWorkflowOnApplicant(applicantId, workflowId) {
    let applicant = await this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(applicantId);
    applicant
      .update({
        workflowArray: null,
        workflowArrayExecuted: null,
      })
      .then(async () => {
        let workflows = [];
        workflows.push(workflowId);
        applicant.update({
          workflowArray: workflows,
        });
      });
  }

  // agents
  getAgents() {
    return this.app2.firestore.collection(FirebaseConstants.agents);
  }

  addAgent(agent) {
    return this.app2.firestore.collection(FirebaseConstants.agents).add(agent);
  }

  updateAgent(agent) {
    return this.app2.firestore
      .collection(FirebaseConstants.agents)
      .doc(agent.id)
      .update(agent);
  }

  deleteAgent(id) {
    return this.app2.firestore
      .collection(FirebaseConstants.agents)
      .doc(id)
      .delete();
  }

  retrieveChatHistory() {
    return this.app2.firestore.collection(FirebaseConstants.ChatHistory);
  }

  async getMatchingPunktzahl() {
    return this.getProfile().get().then((snap) => {
      let docs = snap.docs;
      if (docs.length > 0) {
        var doc = docs[0];
        var data = doc.data();
        return data.minimumMatchingResult;
      }
    });
  }

  // agents API
  getProfile2(): any {
    return this.app2.collection(FirebaseConstants.branding);
  }

  saveZvooveAPIKeys2(data) {
    return this.getProfile2()
      .get()
      .then((snap) => {
        let docs = snap.docs;
        let docLength = docs.length;
        if (docLength > 0) {
          var id = docs[0].id;
          return this.app2
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              zvoove: data.zvoove,
              zvooveBewerberApiKey: data.zvooveBewerberApiKey || '',
              zvooveBewerberApiLink: data.zvooveBewerberApiLink || '',
              zvooveStellenApiKey: data.zvooveStellenApiKey || '',
              zvooveStellenApiLink: data.zvooveStellenApiLink || '',
              zvoooveNextLevelApiKey: data.zvoooveNextLevelApiKey || '',
              zvooveNextLevelApiLink: data.zvooveNextLevelApiLink || '',
              zvooveBewerberApiLinkById: data.zvooveBewerberApiLinkById || '',
              zvooveCreateBewerberApiLink:
                data.zvooveCreateBewerberApiLink || '',
              username: data.username || '',
              password: data.password || '',
              AIMatchingType: data.AIMatchingType || '',
              updated: new Date(),
              status: 'aktiv',
            });
        } else {
          return false;
        }
      });
  }

  saveTalentionAPIKeys2(data) {
    return this.getProfile2()
      .get()
      .then((snap) => {
        let docs = snap.docs;
        let docLength = docs.length;
        if (docLength > 0) {
          var id = docs[0].id;
          return this.app2
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              talention: data.talention,
              talentionClientId: data.talentionClientId || '',
              talentionClientSecret: data.talentionClientSecret || '',
              talentionAccountId: data.talentionAccountId || '',
              talentionAccountOption: data.talentionAccountOption || '',
              talentionAccountOptionBranches:
                data.talentionAccountOptionBranches || '',
              talentionMonaStatusEingang: data.talentionMonaStatusEingang || '',
              talentionMonaStatusImInterview:
                data.talentionMonaStatusImInterview || '',
              talentionMonaStatusInterviewAbgeschlossen:
                data.talentionMonaStatusInterviewAbgeschlossen || '',
              talentionMonaStatusProfilErstellt:
                data.talentionMonaStatusProfilErstellt || '',
              talentionMonaStatusProfilVersendet:
                data.talentionMonaStatusProfilVersendet || '',
              AIMatchingType: data.AIMatchingType || '',
              updated: new Date(),
              status: 'aktiv',
            });
        } else {
          return false;
        }
      });
  }

  saveIndexApiKeyCredentials(accessToken, login, password) {
    return this.getProfile()
      .get()
      .then((snap) => {
        let docs = snap.docs;
        let docLength = docs.length;
        if (docLength > 0) {
          var id = docs[0].id;
          return this.app2
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              indexApiKey: accessToken,
              indexLogin: login,
              indexPassword: password,
              updated: new Date(),
            });
        } else {
          return false;
        }
      });
  }

  saveGoogleCredentials(accessToken, refreshToken, googleProfile) {
    return this.getProfile()
      .get()
      .then((snap) => {
        let docs = snap.docs;
        let docLength = docs.length;
        if (docLength > 0) {
          var id = docs[0].id;
          return this.app2
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              googleAccessToken: accessToken,
              googleRefreshToken: refreshToken,
              googleProfile: googleProfile,
              updated: new Date(),
            });
        } else {
          return false;
        }
      });
  }

  saveMicrosoftCredentials(accessToken, refreshToken, microsoftProfile) {
    return this.getProfile()
      .get()
      .then((snap) => {
        let docs = snap.docs;
        let docLength = docs.length;
        if (docLength > 0) {
          var id = docs[0].id;
          const microsoftProfileObj = JSON.parse(microsoftProfile);
          return this.app2
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              microsoftAccessToken: accessToken,
              microsoftRefreshToken: refreshToken,
              microsoftProfile: microsoftProfileObj,
              updated: new Date(),
            });
        } else {
          return false;
        }
      });
  }

  private async updateTeammemberWithMicrosoftCredentials(
    accessToken,
    microsoftProfile,
    refreshToken,
    snap,
  ) {
    snap.docs.forEach((doc) => {
      let id = doc.id;
      this.getTeammembers().doc(id).update({
        microsoftAccessToken: accessToken,
        microsoftRefreshToken: refreshToken,
        microsoftProfile: microsoftProfile,
      });
    });
  }

  private async addTeammemberWithMicrosoftCredentials(
    accessToken,
    microsoftProfile,
    refreshToken,
  ) {
    this.getTeammembers().add({
      email: microsoftProfile.mail,
      created: new Date(),
      createdIso: new Date().toISOString().split('T')[0],
      status: 'Mitarbeiter*in',
      createdIsoTime: new Date().toISOString(),
      microsoftAccessToken: accessToken,
      microsoftRefreshToken: refreshToken,
      microsoftProfile: microsoftProfile,
    });
  }

  async saveMicrosoftTeamMemberCredentials(
    accessToken,
    refreshToken,
    microsoftProfile,
  ) {
    const microsoftProfileObj = JSON.parse(microsoftProfile);

    this.getTeammembers()
      .where('email', '==', microsoftProfileObj.mail)
      .get()
      .then((snap) => {
        if (snap.docs.length > 0) {
          this.updateTeammemberWithMicrosoftCredentials(
            accessToken,
            microsoftProfileObj,
            refreshToken,
            snap,
          );
        } else {
          this.addTeammemberWithMicrosoftCredentials(
            accessToken,
            microsoftProfileObj,
            refreshToken,
          );
        }
      });

    this.coolStore.firestore
      .collection(FirebaseConstants.customers)
      .where('email', '==', microsoftProfileObj.mail)
      .get()
      .then((snap) => {
        if (snap.docs.length > 0) {
          //do nothing as we do not want to update the token here.
        } else {
          //create a new teamMember without token
          this.AddNewCustomerInCoolstore(microsoftProfileObj.mail);
        }
      });
  }

  AddNewCustomerInCoolstore(email) {
    this.coolStore.firestore.collection(FirebaseConstants.customers).add({
      email: email,
      kundennummer: this.customerNumber,
      created: new Date(),
      createdIso: new Date().toISOString().split('T')[0],
      status: 'Mitarbeiter*in',
      createdIsoTime: new Date().toISOString(),
    });
  }

  saveIMAPCredentials(imapHost, imapPost, imapUsername, imapPassword, imapTLS) {
    return this.getProfile()
      .get()
      .then((snap) => {
        let docs = snap.docs;
        let docLength = docs.length;
        if (docLength > 0) {
          var id = docs[0].id;
          return this.app2
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              imapHost: imapHost,
              imapPost: imapPost,
              imapUsername: imapUsername,
              imapPassword: imapPassword,
              imapTLS: imapTLS,
              updated: new Date(),
            });
        } else {
          return false;
        }
      });
  }

  saveCompleetAPIKeys2(data) {
    return this.getProfile2()
      .get()
      .then((snap) => {
        let docs = snap.docs;
        let docLength = docs.length;
        if (docLength > 0) {
          var id = docs[0].id;
          return this.app2
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              compleet: data.compleet,
              compleetAPIKeys: data.compleetAPIKeys || '',
              updated: new Date(),
              AIMatchingType: data.AIMatchingType || '',
              status: 'aktiv',
            });
        } else {
          return false;
        }
      });
  }

  saveIndexAPIKeys2(data) {
    return this.getProfile2()
      .get()
      .then((snap) => {
        let docs = snap.docs;
        let docLength = docs.length;
        if (docLength > 0) {
          var id = docs[0].id;
          return this.app2
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              index: data.index,
              indexLogin: data.indexLogin || '',
              indexPassword: data.indexPassword || '',
              updated: new Date(),
            });
        } else {
          return false;
        }
      });
  }

  saveZapierAPIKeys2(data) {
    return this.getProfile2()
      .get()
      .then((snap) => {
        let docs = snap.docs;
        let docLength = docs.length;
        if (docLength > 0) {
          var id = docs[0].id;
          return this.app2
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              zapier: data.zapier,
              updated: new Date(),
              status: 'aktiv',
            });
        } else {
          return false;
        }
      });
  }

  saveCustomIntegrationAPIKeys2(data) {
    return this.getProfile2()
      .get()
      .then((snap) => {
        let docs = snap.docs;
        let docLength = docs.length;
        if (docLength > 0) {
          var id = docs[0].id;
          return this.app2
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              customIntegration: data.customIntegration,
              updated: new Date(),
              status: 'aktiv',
            });
        } else {
          return false;
        }
      });
  }

  saveTalent360APIKeys2(data) {
    return this.getProfile2()
      .get()
      .then((snap) => {
        let docs = snap.docs;
        let docLength = docs.length;
        if (docLength > 0) {
          var id = docs[0].id;
          return this.app2
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              talent360: data.talent360,
              talentClientId: data.talentClientId || '',
              talentClientSecret: data.talentClientSecret || '',
              talentAPIBaseUrl: data.talentAPIBaseUrl || '',
              talentAccessTokenUrl: data.talentAccessTokenUrl || '',
              talentPublicAudience: data.talentPublicAudience || '',
              updated: new Date(),
              status: 'aktiv',
            });
        } else {
          return false;
        }
      });
  }

  sendVideos() {
    // part for new video generation collecting all Videos from customers
    // let i = 1;
    // this.app2.firestore.collection(FirebaseConstants.videos).get().then(async (snap) => {
    //   await snap.forEach((doc) => {
    //     let video = doc.data();
    //     this.videoStore.firestore.collection(FirebaseConstants.videos).add(video).then(() => {
    //       console.log(i++);
    //     })
    //   })
    // })
  }

  async addToVideosToBeGenerated(videosToGenerate: any[]) {
    let collectionRef = await this.app2.firestore.collection(
      FirebaseConstants.videosInProgress,
    );
    if (collectionRef) {
      videosToGenerate.forEach(async (video) => {
        video.created = new Date();
        await collectionRef.add(video);
      });
    }
  }

  getVideosInProgress() {
    return this.app2.firestore.collection(FirebaseConstants.videosInProgress);
  }

  deleteVideoInProgress(text, language, avatarId) {
    const firestore = this.app2.firestore;
    const collectionRef = firestore.collection(
      FirebaseConstants.videosInProgress,
    );

    return collectionRef
      .where('text', '==', text)
      .where('langCode', '==', language)
      .where('avatarId', '==', avatarId)
      .get()
      .then((snap) => {
        if (snap.empty) {
          console.log('No matching documents found for deletion.');
          return;
        }

        const batch = firestore.batch();

        snap.forEach((doc) => {
          batch.delete(doc.ref);
        });

        return batch.commit().then(() => {
          console.log('Documents successfully deleted.');
        });
      })
      .catch((error) => {
        console.error('Error deleting documents: ', error);
      });
  }

  getMonaLogs(applicantId) {
    let errors = [];
    return this.app2.firestore
      .collection(FirebaseConstants.monaLogs)
      .doc(applicantId)
      .collection(FirebaseConstants.errors)
      .get()
      .then((snap) => {
        snap.forEach((doc) => {
          if (doc.exists) {
            let data = doc.data();
            let timestamp = data.created;
            if (timestamp instanceof Date) {
              data.created = timestamp;
            } else {
              data.created = timestamp.toDate();
            }
            errors.push(data);
          }
          // if (snap.exists) {
          //   let data = snap.data();
          //   let errors = data.errorArray;
          //   for (let error of errors) {
          //   }
          //   return errors;
          // };
        });
        return errors;
      });
  }

  // notifications
  public updateLastLoginTime(userId: string): Promise<void> {
    return this.app2.firestore.doc(`users/${userId}`).update({
      lastLoginTime: firebase.firestore.FieldValue.serverTimestamp(),
    });
  }

  // Applicants seit letztem Login
  public getApplicantsSince(lastLogin: Date): Observable<any[]> {
    return this.app2.firestore
      .collection('customers/kunde1001/applicants', (ref) =>
        ref.where('createdAt', '>', lastLogin),
      )
      .valueChanges();
  }

  // Tutorials seit letztem Login
  public getTutorialsSince(lastLogin: Date): Observable<any[]> {
    return this.app2.firestore
      .collection('tutorials', (ref) =>
        ref.where('creationDate', '>', lastLogin),
      )
      .valueChanges();
  }

  // Integrationen seit letztem Login
  public getIntegrationsSince(lastLogin: Date): Observable<any[]> {
    return this.app2.firestore
      .collection('integrations', (ref) =>
        ref.where('createdAt', '>', lastLogin),
      )
      .valueChanges();
  }

  // get all workflows with flag isCommunication as true
  async getAllCommunicationWorkflows() {
    let workflows = [];
    await this.app2.firestore.collection(FirebaseConstants.workflows).get().then((snap) => {
      snap.forEach((doc) => {
        let data = doc.data();
        if (data.isCommunication) {
          let obj = {
            id: data.id,
            name: data.name
          }
          workflows.push(obj);
        }
      })
    })
    return workflows;
  }

  public setUserEmail(email: string) {
    this.userEmail = email;
  }

  public getUserEmail(): string {
    return this.userEmail;
  }

  public checkIfUserHasMicrosoftTokens() {
    return new Promise((resolve) => {
      this.getTeammembers()
        .where('email', '==', this.userEmail)
        .get()
        .then((snap) => {
          if (snap.docs.length > 0) {
            snap.docs.forEach((doc) => {
              let data = doc.data();
              //should be only 1 doc
              resolve(
                data.microsoftAccessToken !== undefined &&
                data.microsoftRefreshToken !== undefined,
              );
            });
          }
          resolve(false);
        });
    });
  }

  public saveMicrosoftSMTPCredentials(microsoftProfileEmail) {
    this.getProfile()
      .get()
      .then((snap) => {
        if (snap.docs.length > 0) {
          var id = snap.docs[0].id;
          this.getProfile().doc(id).update({
            smtpHost: 'smtp.office365.com',
            smtpPort: 465,
            smtpEmail: microsoftProfileEmail,
          });
        }
      });
  }

  // Add these methods for CRM functionality
  private getFirebaseService() {
    if (!this.firebaseService) {
      try {
        this.firebaseService = this.injector.get('FirebaseService');
      } catch (error) {
        console.error('FirebaseService not available yet, retrying...');
        // Return a mock for now
        return {
          returnSalesEmails: () => ({
            orderBy: () => ({
              limit: () => ({ get: async () => ({ empty: true, docs: [] }) }),
            }),
          }),
          returnSalesEmailsSparkasse: () => ({
            orderBy: () => ({
              limit: () => ({ get: async () => ({ empty: true, docs: [] }) }),
            }),
          }),
          returnSalesEmailsNormalCustomers: () => ({
            orderBy: () => ({
              limit: () => ({ get: async () => ({ empty: true, docs: [] }) }),
            }),
          }),
        };
      }
    }
    return this.firebaseService;
  }

  async getEmailStats(): Promise<any[]> {
    try {
      // Get customer number to determine which query to use
      const customerNumber = this.getCustomerNumber();
      const businessName = this.returnBusinessName();
      let collection;

      if (!businessName) return [];
      collection = firebase
        .firestore()
        .collection('emailsToBeSentGeneral')
        .doc(businessName)
        .collection('emailsToBeSent');
      // }

      const query = collection.orderBy('created', 'desc').limit(1000);
      const snapshot = await query.get();

      if (snapshot.empty) return [];

      return snapshot.docs.map((doc) => {
        const data = doc.data();
        data.id = doc.id;

        // Process criteriaFulfilled to make it consistent
        if (data.resJob && data.resJob.content) {
          const resJob = data.resJob.content;
          data.matchingPunktzahl = resJob.matchingPunktzahl || 0;

          if ('erfülltMussKriterien' in resJob) {
            data.criteriaFulfilled = resJob['erfülltMussKriterien'];
          } else {
            data.criteriaFulfilled = false;
          }
        }

        return data;
      });
    } catch (error) {
      console.error('Error fetching email stats:', error);
      return [];
    }
  } //

  async getCompanies(): Promise<any[]> {
    try {
      const emails = await this.getEmailStats();
      const uniqueCompanies = new Map();

      emails.forEach((email) => {
        if (!email.company) return;

        // Only add if not already in the map
        if (!uniqueCompanies.has(email.company)) {
          const company = {
            name: email.company || '',
            location: email.location || '',
            industry: email.position || '',
            phone: email.companyPhone || '',
            website: email.companyLink || '',
            contactPerson: email.contactPerson || '',
            email: email.contactPersonEmail || '',
            status: email.contacted ? 'contacted' : 'not_contacted',
            logoUrl: '',
          };
          uniqueCompanies.set(email.company, company);
        }
      });

      return Array.from(uniqueCompanies.values());
    } catch (error) {
      console.error('Error fetching companies:', error);
      return [];
    }
  }

  async updateEmailStatus(emailId: string, status: string): Promise<void> {
    try {
      const customerNumber = this.getCustomerNumber();
      let collection;

      const businessName = this.returnBusinessName();
      if (!businessName) throw new Error('Business name not found');
      collection = firebase
        .firestore()
        .collection('emailsToBeSentGeneral')
        .doc(businessName)
        .collection('emailsToBeSent');

      await collection.doc(emailId).update({
        contacted: status === 'contacted',
        status: status,
        lastUpdated: new Date().toISOString(),
      });
    } catch (error) {
      console.error('Error updating email status:', error);
      throw error;
    }
  }

  /**
   * Gets all ATS connections for the current account
   */
  async getConnections() {
    try {
      const snapshot = await this.app2.firestore
        .collection('ats_connections')
        .get();

      return snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
    } catch (error) {
      console.error('Error getting connections:', error);
      throw error;
    }
  }

  async getAllAgentNames(): Promise<string[]> {
    const snapshot = await this.app2.firestore.collection(FirebaseConstants.agents).get();
    const agentNames = snapshot.docs.map(doc => doc.data().name);
    return agentNames;
  }


  async getAllowedTools(): Promise<string[]> {
    try {
      //now the branding collection in mona-test1 only has this file
      const brandingSnap = await this.app2.firestore.collection(FirebaseConstants.branding).doc("gWzdiHsVSN1LoD9hzrZM").get();
      if (brandingSnap.exists) {
        let Tools = brandingSnap.data().allowed_tools;
        const allowedTools = Object.keys(Tools).filter(key => Tools[key]);
        return allowedTools;
      } else {
        console.error("Branding document does not exist.");
      }
    } catch (error) {
      console.error("Failed to fetch allowed tools from Firebase:", error);
    }

    // Fallback: return all available tools from local mapping
    try {
      const toolInfosMapping = await import('../mona-agent-builder/tool_infos_mapping.json');
      const toolInfos = toolInfosMapping.default || toolInfosMapping;
      const allToolNames = Object.values(toolInfos).map((tool: any) => tool.name);
      console.log("Using all available tools as fallback:", allToolNames);
      return allToolNames;
    } catch (fallbackError) {
      console.error("Failed to load fallback tools:", fallbackError);
      return [];
    }
  }

  async getToolsInfo() {
    try {
      const toolInfoSnap = await this.app2.firestore.collection(FirebaseConstants.systemConfig).doc("tool_infos_mapping").get();

      if (toolInfoSnap.exists) {
        const toolInfos = toolInfoSnap.data();
        const toolInfosData = Object.values(toolInfos);
        return toolInfosData;
      } else {
        console.warn("Tool info mapping document does not exist in Firebase, using local fallback");
      }
    } catch (error) {
      console.error("Failed to fetch tool info from Firebase:", error);
      console.log("Using local fallback tool_infos_mapping.json");
    }

    // Fallback to local JSON file
    try {
      const toolInfosMapping = await import('../mona-agent-builder/tool_infos_mapping.json');
      const toolInfosData = Object.values(toolInfosMapping.default || toolInfosMapping);
      console.log("Successfully loaded tool info from local fallback");
      return toolInfosData;
    } catch (fallbackError) {
      console.error("Failed to load local tool_infos_mapping.json:", fallbackError);
      return null;
    }
  }

  // General agent creation method using unified endpoint
  async createAgent(agentData: any): Promise<any> {
    const apiKey = await this.getApiKey();
    const uid = this.returnUserId();

    const payload = {
      apiKey: apiKey,
      uid: uid,
      permission: "pushAgents",
      agentData: agentData
    };

    console.log("createAgent payload", payload);

    try {
      const response: any = await this.http.post('https://api.mona-ai.cloud/agent/createAgent', payload, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).toPromise();
      return response;
    } catch (error) {
      console.error('Error creating agent:', error);
      throw error;
    }
  }

  // Agent creation API methods (legacy)
  async createCustomAgent(name: string, description: string, selectedTools?: string[]): Promise<any> {
    const apiKey = await this.getApiKey();
    const uid = this.returnUserId();

    const payload: any = {
      apiKey: apiKey,
      uid: uid,
      permission: "pushAgents",
      name: name,
      description: description
    };

    // Add tools if provided
    if (selectedTools && selectedTools.length > 0) {
      payload.tools = selectedTools;
    }


    console.log("payload", payload);

    try {
      const response: any = await this.http.post('https://api.mona-ai.cloud/agent/createCustomAgent', payload, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).toPromise();
      return response;
    } catch (error) {
      console.error('Error creating custom agent:', error);
      throw error;
    }
  }

  async createMonariAgent(name: string, expertiseAreas: string[], greetingMessage: string, systemPrompt: string): Promise<any> {
    const apiKey = await this.getApiKey();
    const uid = this.returnUserId();

    // const payload = {
    //   apiKey: "cf8513cce323b0425b1c7eecbc9371f5ac09f90e7462fee8f7c36eea796ef17f",
    //   uid: "YHHSoY2I7BdR9rpsaKkD7YWDRgA3",
    //   permission: "pushAgents", 
    //   name: name,
    //   expertise_areas: expertiseAreas,
    //   greeting_message: greetingMessage,
    //   system_prompt: systemPrompt
    // };

    const payload = {
      apiKey: apiKey,
      uid: uid,
      permission: "pushAgents",
      name: name,
      expertise_areas: expertiseAreas,
      greeting_message: greetingMessage,
      system_prompt: systemPrompt
    };
    try {
      const response: any = await this.http.post('https://api.mona-ai.cloud/agent/createMonariAgent', payload, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).toPromise();
      return response;
    } catch (error) {
      console.error('Error creating Monari agent:', error);
      throw error;
    }
  }

  async executeAgentTool(tool: string, payload: any): Promise<any> {
    const requestPayload = {
      tool: tool,
      payload: payload
    };

    console.log("executeAgentTool payload", requestPayload);

    try {
      const response: any = await this.http.post('https://api.mona-ai.cloud/agent/tool_execution', requestPayload, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).toPromise();
      return response;
    } catch (error) {
      console.error('Error executing agent tool:', error);
      throw error;
    }
  }

  async getApiKey(): Promise<string> {
    try {
      // First try to get from user's document
      const userId = this.returnUserId();
      if (userId) {
        const userDoc = await this.db.collection('users').doc(userId).get();
        if (userDoc.exists && userDoc.data()?.apiKey) {
          return userDoc.data().apiKey;
        }
      }

      // Fallback: try to get from profile
      const profile = await this.getProfile().get();
      if (profile && profile.docs.length > 0) {
        const profileData = profile.docs[0].data();
        if (profileData.apiKey) {
          return profileData.apiKey;
        }
      }

      // If no API key found, throw error to trigger generation
      throw new Error('No API key found');
    } catch (error) {
      console.log('No API key found, will need to generate one');
      throw error;
    }
  }

  async saveApiKey(apiKey: string): Promise<void> {
    try {
      // Assuming there's a collection or document to store the API key
      const userId = this.returnUserId();
      if (!userId) {
        throw new Error('User not authenticated');
      }

      // Save the API key in the user's document
      await this.db.collection('users').doc(userId).set({
        apiKey: apiKey
      }, { merge: true });

      console.log('API key saved successfully');
    } catch (error) {
      console.error('Error saving API key:', error);
      throw error;
    }
  }

  public async postRequest(url: string, body: any, options?: any): Promise<any> {
    try {
      return await this.http.post(url, body, options).toPromise();
    } catch (error) {
      console.error('HTTP POST request failed:', error);
      throw error;
    }
  }

  async storeProfileTemplate(templateData: any) {
    return this.app2.firestore
      .collection(FirebaseConstants.profileTemplates)
      .add({
        ...templateData,
        customerNumber: this.getCustomerNumber(),
        created: new Date(),
        createdISO: new Date().toISOString()
      });
  }

  async getProfileTemplates() {
    const snapshot = await this.app2.firestore
      .collection(FirebaseConstants.profileTemplates)
      .where('customerNumber', '==', this.getCustomerNumber())
      .orderBy('created', 'desc')
      .get();

    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  }

  async updateProfileTemplate(templateId: string, templateData: any) {
    return this.app2.firestore
      .collection(FirebaseConstants.profileTemplates)
      .doc(templateId)
      .update({
        ...templateData,
        updated: new Date(),
        updatedISO: new Date().toISOString()
      });
  }

  async deleteProfileTemplate(templateId: string) {
    return this.app2.firestore
      .collection(FirebaseConstants.profileTemplates)
      .doc(templateId)
      .delete();
  }

}
